import React, { useState, useEffect, useCallback, useRef, useMemo } from 'react'
import './../../App.css';
import './Employees.css';
import { CreateButton, CreateSearchBarWithPlaceHolder} from './../CommonObjects';
import {SetAuditTrail} from './../Reports/AuditTrailReportEmployeeSetup';
import ViewEmployee from './ViewEmployee';
import axios from 'axios';
import {useTable, useSortBy} from 'react-table';
import {token, domain} from './../Security';
import loadingSpinner from './../../assets/loading.gif';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
// icons
import SettingsIcon from '@mui/icons-material/Settings';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import SearchIcon from '@mui/icons-material/Search';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import DownloadIcon from '@mui/icons-material/Download';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import GroupsIcon from '@mui/icons-material/Groups';
import CloseIcon from "@mui/icons-material/Close";
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import DoneIcon from '@mui/icons-material/Done';
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
import FileOpenIcon from '@mui/icons-material/FileOpen';
import ChecklistIcon from '@mui/icons-material/Checklist';

function EmployeesList({user, userAccess, employeePhoto, setEmployeePhoto, isHideSideMenu}) {
    var header = [
        // "Photo",
        "ID",
        "Full Name",
        "Department",
        // "Date Created",
        "Is Approved?",
        ""
    ]
    var accessor = [
        // "avatar",
        "employeeId",
        "fullName",
        "employeeInformation.departmentDescription",
        // "employeeInformationCreatedDate",
        "employeeInformation.employeeInformationStatus",
        "manage"
    ]
    const [showSetting, setShowSetting] = useState(false);
    const settingRef = useRef(null);
    const buttonRef = useRef(null);

    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [loadingRequest, setLoadingRequest] = useState(false);
    const [loadingUploadRequest, setLoadingUploadRequest] = useState(false);
    const [showUploadForm, setShowUploadForm] = useState(false);
    const [showUploadForBulkUpdateForm, setShowUploadForBulkUpdateForm] = useState(false);
    const [showUploadLeaveUpdateForm, setShowUploadLeaveUpdateForm] = useState(false);
    const [showBiometricsListForm, setShowBiometricsListForm] = useState(false);
    const [selectedEmployee, setSelectedEmployee] = useState([]);
    const [selectedToApprove, setSelectedToApprove] = useState([]);
    
    const [isSelectAll, setIsSelectAll] = useState(false);
    const [activeRowIds, setActiveRowIds] = useState([]); // Array to store active row IDs

    const [classificationFilterForAdminHRHead, setClassificationFilterForAdminHRHead] = useState("0");
    const [classificationFilterForHRAsst2, setClassificationFilterForHRAsst2] = useState("2");
    const [classificationFilterForHRAsst3, setClassificationFilterForHRAsst3] = useState("4");
    const [currentClassificationFilter, setCurrentClassificationFilter] = useState("");
    const [sectionFilter, setSectionFilter] = useState("0");
    const [locationFilter, setLocationFilter] = useState("0");
    const [sortFilter, setSortFilter] = useState("");
    const [currentSectionFilter, setCurrentSectionFilter] = useState("");
    const [currentLocationFilter, setCurrentLocationFilter] = useState("");
    const [currentSortFilter, setCurrentSortFilter] = useState("");
    const [userAccessData, setUserAccessData] = useState([]);

    // Connect to API
    const [employees, setEmployees] = useState([]);
    // const [employeesBasicInfo, setEmployeesBasicInfo] = useState([]);
    const [allEmployeesBasicInfo, setAllEmployeesBasicInfo] = useState([]);
    const [filterData, setFilterData] = useState([]);
    const [filterDataIndex, setFilterDataIndex] = useState(0);
    const [searchPlaceholder, setSearchPlaceholder] = useState("name");
    //ViewEmployee
    const [isUpdate, setIsUpdate] = useState(false);
    const [showViewEmployee, setShowViewEmployee] = useState(false);
    const [viewedData, setViewedData] = useState([]);
    //Request Messages -start
    const [showRequestMessage, setShowRequestMessage] = useState(false);
    const [requestMessage, setRequestMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState("");
    // const [showRequestWarningMessage, setShowRequestWarningMessage] = useState(false);
    // const [requestWarningMessage, setRequestWarningMessage] = useState("");
    useEffect(() => {
        if (showRequestMessage) {
            const timeoutId = setTimeout(() => {
                setShowRequestMessage(false);
            }, 5000);

            return () => clearTimeout(timeoutId);
        }
        
    }, [showRequestMessage]);
    /* useEffect(() => {
        if (showRequestWarningMessage) {
            const timeoutId = setTimeout(() => {
                setShowRequestWarningMessage(false);
            }, 5000);

            return () => clearTimeout(timeoutId);
        }
        
    }, [showRequestWarningMessage]); */
    function GenerateMessage({form, message, isSuccess}){
        return (
            <>
                <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
                    {form && (
                    <div className="modal toggleMessage" style={{backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5"}}>
                        <div className='column'>
                            {isSuccess ?
                                <div className='request_title row' style={{fontWeight:"bold", color:"green", alignItems:"center"}}>
                                    <CheckCircleIcon/>
                                    <span >{"SUCCESS MESSAGE"}</span>
                                </div>
                                :
                                <div className='request_title row' style={{fontWeight:"bold", color:"#DD5746", alignItems:"center"}}>
                                    <ErrorIcon/>
                                    <span>{"ERROR MESSAGE"}</span>
                                </div>
                            }
                            <span style={{textAlign:"center", padding:"10px 0", color: isSuccess? "green" : "#DD5746"}}>{message}</span>
                        </div>
                    </div>
                )}
                </div>
            </>
        );
    }
    /* function GenerateWarningMessage({form, message}){
        return (
            <>
                <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
                {form && (
                    <div className="modal toggleMessage warning-message" style={{backgroundColor: "#ffd0c5"}}>
                        <div className='column'>
                            <div className='request_title row' style={{fontWeight:"bold", color:"#DD5746", alignItems:"center"}}>
                                <ErrorIcon/>
                                <span>{"WARNING MESSAGE"}</span>
                            </div>
                            <span style={{textAlign:"center", padding:"10px 0", color: "#DD5746"}}>{message}</span>
                        </div>
                    </div>
                )}
                </div>
            </>
        );
    } */
    //Request Messages -end

    const handleFilter = (value) => {
        const lowercaseValue = value.toLowerCase();
        setCurrentPage(1);
        var res = [];

        switch (filterDataIndex) {
            case 0:
                res = filterData.filter((f) =>
                f?.fullName?.toLowerCase().includes(lowercaseValue)
                );
                break;
            case 1:
                res = filterData.filter((f) =>
                f?.employeeId?.toString().startsWith(lowercaseValue)
                );
                break;
            case 2:
                res = filterData.filter((f) =>
                f?.fullName?.toLowerCase().includes(lowercaseValue)
                );
                break;
            case 3:
                res = filterData.filter((f) =>
                f?.fullName?.toLowerCase().includes(lowercaseValue)
                );
                break;
            default:
                res = filterData.filter((f) =>
                f.fullName?.toLowerCase().includes(lowercaseValue)
                );
                
                break;
        }
        setEmployees(res);
    }

    const handleUpdate = async () => {
        const apiUrl =  domain + "/api/Employee/update-status/bulk";

        if(selectedEmployee.length <= 0) {
            setShowRequestMessage(true);
            setIsSuccess(false);
            setRequestMessage("Nothing to update.");
            return;
        }

        const data = selectedEmployee.map(_employee => {
            return {
                employeePersonalInformationId: _employee.id,
                status: "Approved"
            };
        })

        try {
            // setLoadingRequest(true);
            await axios.put(apiUrl, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            // Reload table data and reset form fields
            await fetchDataBasicInfo();
            setRequestMessage('Upload successful');
            setShowRequestMessage(true);
            setIsSuccess(true);
            setActiveRowIds([]);
            setSelectedEmployee([]);
        } catch (error) {
            // setLoadingRequest(false);
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }
    };

    const apiUrl =  domain + "/api/Employee/";

    const fetchDataAccessTemplate =  useCallback(async () => {
        const apiUrl =  domain + "/api/AccessTemplate";

            try {
                setLoading(true);
                const response = await axios.get(apiUrl , {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json' // You can include other headers if needed
                }})
                return response.data;
            } catch (error) {
            console.error('Error fetching data:', error);
            return [];
        }
    }, []);
    const fetchDataEmployeeInfoForMasterlist = useCallback(async () => {
        const apiUrl =  domain + "/api/Employee/masterlist";

        try {
            const response = await axios.get(apiUrl, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
            }})
                return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            return []
        }
    }, []);
    const fetchDataEmployeeInformationOnly = useCallback(async () => {
        const apiUrl =  domain + "/api/Employee/employee-information-only";

        try {
            const response = await axios.get(apiUrl, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
            }})
                return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            return []
        }
    }, []);
    const fetchDataAccounts = useCallback(async () => {
        const apiUrl =  domain + "/api/Authentication";

        try {
            setLoading(true);
            const response = await axios.get(apiUrl , {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json' // You can include other headers if needed
            }})
            return response.data; 
        } catch (error) {
            console.error('Error fetching data:', error);
            return []
        }
    }, []);
    const fetchDataEmployeeById = useCallback(async (id) => {
        try {
            const response = await axios.get(apiUrl + `${id}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            return response.data;
            
        } catch (error) {
            console.error('Error fetching data:', error);
            return [];
        }
    }, [apiUrl]);

    const [unapprovedEmployees, setUnapprovedEmployees] = useState([]);
    const [showUnapprovedEmployees, setShowUnapprovedEmployees] = useState(false);
    const [showOnce, setShowOnce] = useState(false);
    const openUnapprovedEmployees = () => {
        setShowUnapprovedEmployees(true);
    }
    const closeUnapprovedEmployees = () => {
        setShowUnapprovedEmployees(false);
    }

    /* useEffect(() => {
        if(userAccess.description === "HR Head" || userAccess.description === "Admin"){
            if(unapprovedEmployees.length > 0){
                openUnapprovedEmployees();
            }
        }
    }, [userAccess, unapprovedEmployees]) */

    useEffect(() => {
            if(unapprovedEmployees.length > 0 && !showOnce){
                openUnapprovedEmployees();
                setShowOnce(true)
            }
    }, [unapprovedEmployees, showOnce])

    const fetchDataBasicInfo = useCallback(async () => {
        setLoading(true);

        try {
            const response = await axios.get(apiUrl + `single-data`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
            }})

            let _filteredData = response.data;

            if(filterDataIndex === 2){ //Approved Employees
                const approvedEmployees = response.data.filter(employee => {
                    return employee.employeeInformation.employeeInformationStatus === "Approved"
                });

                _filteredData = approvedEmployees;
            } else if(filterDataIndex === 3){ //Pending Employees
                const pendingEmployees = response.data.filter(employee => {
                    return employee.employeeInformation.employeeInformationStatus !== "Approved"
                });

                _filteredData = pendingEmployees;
            }

            const _unapprovedEmployees = response.data.filter(employee => {
                return employee.employeeInformation.employeeInformationStatus !== "Approved"
            })
            .sort((a, b) => a.fullName.localeCompare(b.fullName));;
            setUnapprovedEmployees(_unapprovedEmployees)

            setUserAccessData(userAccess);
            setAllEmployeesBasicInfo(_filteredData);
            setEmployees(_filteredData);
            setFilterData(_filteredData);
            setIsUpdate(true);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    }, [apiUrl, 
        filterDataIndex, 
        userAccess
    ]);

    useEffect(()=>{
        let classifiedData = allEmployeesBasicInfo;
        let classificiationFilter = classificationFilterForAdminHRHead;

        if(userAccess){
            if(userAccess.description === "Admin" || userAccess.description === "HR Head" || userAccess.description === "HR Assistant"){
                classificiationFilter = classificationFilterForAdminHRHead;
            } else if(userAccess.description === "HR Assistant2"){
                classificiationFilter = classificationFilterForHRAsst2;
            } else if(userAccess.description === "HR Assistant3"){
                classificiationFilter = classificationFilterForHRAsst3;
            }
        }

        setCurrentClassificationFilter(classificiationFilter);
        setCurrentSectionFilter(sectionFilter);
        setCurrentLocationFilter(locationFilter);
        setCurrentSortFilter(sortFilter);

        if(classificiationFilter !== "0"){
            const _classified = allEmployeesBasicInfo.filter(employee => {
                
                if (employee.employeeInformation && employee.employeeInformation.classificationId) {
                    return employee.employeeInformation.classificationId.toString() === classificiationFilter;
                }
                return false;
            });
            
            classifiedData = _classified;
        }

        let filteredBySection = classifiedData;

        if(sectionFilter !== "0"){
            filteredBySection = classifiedData.filter(_data => {
                return  _data.employeeInformation && 
                    _data.employeeInformation.sectionId && 
                    _data.employeeInformation.sectionId.toString() === sectionFilter.toString();
            });
        }

        if (sortFilter === "Name (A to Z)") {
            filteredBySection.sort((a, b) => a.fullName.localeCompare(b.fullName));
        } else if (sortFilter === "Name (Z to A)") {
            filteredBySection.sort((a, b) => b.fullName.localeCompare(a.fullName));
        } else if (sortFilter === "Employee Id (lowest to highest)") {
            filteredBySection.sort((a, b) => parseInt(a.employeeId) - parseInt(b.employeeId));
        } else if (sortFilter === "Employee Id (highest to lowest)") {
            filteredBySection.sort((a, b) => parseInt(b.employeeId) - parseInt(a.employeeId));
        }

        let lastData = filteredBySection;

        if(locationFilter !== "0"){
            lastData = filteredBySection.filter(i => i.employeeInformation?.locationId?.toString() === locationFilter?.toString());
        }

        if(classificiationFilter !== currentClassificationFilter 
            || sectionFilter !== currentSectionFilter
            || locationFilter !== currentLocationFilter
            || sortFilter !== currentSortFilter
            || isUpdate
        ){
            setEmployees(lastData);
            setFilterData(lastData);
            setIsUpdate(false);

            if(classificiationFilter !== currentClassificationFilter ){
                setSectionFilter("0");
                setLocationFilter("0")
            }
        }
    }, [
        classificationFilterForAdminHRHead, 
        classificationFilterForHRAsst2, 
        classificationFilterForHRAsst3,
        currentClassificationFilter,
        sortFilter,
        currentSortFilter,
        employees,
        allEmployeesBasicInfo,
        userAccess,
        isUpdate,
        sectionFilter,
        currentSectionFilter,
        locationFilter,
        currentLocationFilter
    ])

    useEffect(() => {
        fetchDataBasicInfo();
        switch (filterDataIndex) {
            case 0:
                setSearchPlaceholder("name");
                break;
            case 1:
                setSearchPlaceholder("employee id");
                break;
            case 2:
                setSearchPlaceholder("name");
                break;
            case 3:
                setSearchPlaceholder("name");
                break;
            default:
                setSearchPlaceholder("name");
                break;
        }
    }, [fetchDataBasicInfo, filterDataIndex]);

    const addHandleClick = () =>{
        window.location.pathname = "/addEmployee";
    }
    const viewEmployeeHandleClick = async (data) =>{
        setLoading(true);

        const employeeInfo = await fetchDataEmployeeById(data.id);
        setViewedData(employeeInfo);
        
        setLoading(false);
        setShowViewEmployee(true);
    }
    const closeViewEmployeeHandleClick = () =>{
        setShowViewEmployee(false);
    }

    const openUploadFormHandleClick  = () =>{
        setShowUploadForm(true);
    }
    const closeUploadFormHandleClick = () =>{
        setShowUploadForm(false);
    }
    const openUploadForBulkUpdateEmployeeInformationFormHandleClick  = () =>{
        setShowUploadForBulkUpdateForm(true);
    }
    const closeUploadForBulkUpdateEmployeeInformationFormHandleClick = () =>{
        setShowUploadForBulkUpdateForm(false);
    }
    const openBiometricsListFormHandleClick  = () =>{
        setShowBiometricsListForm(true);
    }
    const closeBiometricsListFormHandleClick = () =>{
        setShowBiometricsListForm(false);
    }
    const openUploadLeaveFormHandleClick  = () =>{
        setShowUploadLeaveUpdateForm(true);
    }
    const closeUploadLeaveFormHandleClick = () =>{
        setShowUploadLeaveUpdateForm(false);
    }

    

    const fetchDataForLocation = useCallback(async () => {
        const apiUrl =  domain + "/api/Location/active";

        try {
            const response = await axios.get(apiUrl, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
            }})
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            return [];
        }
    }, []);
    const fetchDataForEmployment = useCallback(async () => {
        const apiUrl =  domain + "/api/Employment/active";

        try {
            const response = await axios.get(apiUrl, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
            }})
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            return [];
        }
    }, []);
    const fetchDataForDepartment = useCallback(async () => {
        const apiUrl =  domain + "/api/Department/active";

        try {
            const response = await axios.get(apiUrl, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
            }})
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            return [];
        }
    }, []);
    const fetchDataForSection = useCallback(async () => {
        const apiUrl =  domain + "/api/Section/active";

        try {
            const response = await axios.get(apiUrl, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
            }})
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            return [];
        }
    }, []);
    const fetchDataForClassification = useCallback(async () => {
        const apiUrl =  domain + "/api/Classification/active";

        try {
            const response = await axios.get(apiUrl, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
            }})
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            return [];
        }
    }, []);
    const fetchDataForPaytype = useCallback(async () => {
        const apiUrl =  domain + "/api/Paytype/active";

        try {
            const response = await axios.get(apiUrl, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
            }})
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            return [];
        }
    }, []);
    const fetchDataForShiftSchedule = useCallback(async () => {
        const apiUrl =  domain + "/api/ShiftSchedule/";

        try {
            const response = await axios.get(apiUrl, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
            }})
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            return [];
        }
    }, []);
    const fetchDataForPosition = useCallback(async () => {
        const apiUrl =  domain + "/api/Position/active";

        try {
            const response = await axios.get(apiUrl, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
            }})
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            return [];
        }
    }, []);
    const fetchDataForCompany = useCallback(async () => {
        const apiUrl =  domain + "/api/Company/active";

        try {
            const response = await axios.get(apiUrl, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
            }})
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            return [];
        }
    }, []);
    const fetchSalaryType = useMemo(
        () => ["Daily", "Monthly", "QuotaBased", "PositionDesignation"],
        []
    );
    const fetchDataForJobTitle = useCallback(async () => {
        const apiUrl =  domain + "/api/JobTitle/active";

        try {
            const response = await axios.get(apiUrl, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
            }})
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            return [];
        }
    }, []);
    const fetchDataForEmployeeGroup1 = useCallback(async () => {
        const apiUrl =  domain + "/api/EmployeeGroup1/active";

        try {
            const response = await axios.get(apiUrl, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
            }})
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            return [];
        }
    }, []);
    const fetchDataForEmployeeGroup2 = useCallback(async () => {
        const apiUrl =  domain + "/api/EmployeeGroup2/active";

        try {
            const response = await axios.get(apiUrl, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
            }})
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            return [];
        }
    }, []);
    const fetchDataForPlantilya = useCallback(async () => {
        const apiUrl =  domain + "/api/Plantilya/active";

        try {
            const response = await axios.get(apiUrl, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
            }})
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            return [];
        }
    }, []);
    const fetchDataForCostCenter = useCallback(async () => {
        const apiUrl =  domain + "/api/CostCenter/active";

        try {
            const response = await axios.get(apiUrl, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
            }})
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            return [];
        }
    }, []);
    const fetchDataForClient = useCallback(async () => {
        const apiUrl =  domain + "/api/Client/active";

        try {
            const response = await axios.get(apiUrl, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
            }})
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            return [];
        }
    }, []);
    
    async function addDropdownList(workbook, worksheet, { column, startRow, endRow, listName, data }) {
      // 1️⃣ Find or create the hidden Lists sheet
      let listsSheet = workbook.getWorksheet('Lists');
      if (!listsSheet) {
        listsSheet = workbook.addWorksheet('Lists');
        listsSheet.state = 'hidden';
        listsSheet.getCell('A1').value = '__hidden_validation_list__';
      }

      // 2️⃣ Determine the first empty column in Lists
      let colIndex = listsSheet.actualColumnCount + 1;
      if (colIndex < 2) colIndex = 2; // skip A1 marker

      // 3️⃣ Write header and data
      listsSheet.getCell(1, colIndex).value = listName;
      data.forEach((val, idx) => {
        listsSheet.getCell(idx + 2, colIndex).value = val;
      });

      // 4️⃣ Build the reference range (e.g. Lists!$B$2:$B$84)
      const lastListRow = data.length + 1;
      const colLetter = listsSheet.getColumn(colIndex).letter;
      const listRange = `Lists!$${colLetter}$2:$${colLetter}$${lastListRow}`;

      // 5️⃣ Apply dropdown to target cells
      for (let i = startRow; i <= endRow; i++) {
        worksheet.getCell(`${column}${i}`).dataValidation = {
          type: 'list',
          allowBlank: true,
          formulae: [`=${listRange}`],
          showErrorMessage: true,
          errorStyle: 'warning',
          errorTitle: `Invalid ${listName}`,
          error: `Please select a valid ${listName} from the dropdown.`,
          showInputMessage: true,
          promptTitle: `Select ${listName}`,
          prompt: `Choose a ${listName} from the dropdown.`,
        };
      }
    }

    const generateDownloadTemplate = useCallback(async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet1 = workbook.addWorksheet('EmployeePersonalInformation');
        const worksheet2 = workbook.addWorksheet('EmployeeInformation');
        const worksheet3 = workbook.addWorksheet('AccountInformation');
        const worksheet4 = workbook.addWorksheet('BankAccount');
        const worksheet5 = workbook.addWorksheet('EmployeeSalary');
        const worksheet6 = workbook.addWorksheet('Dependents');
        const worksheet7 = workbook.addWorksheet('EducationalAttainment');
        const worksheet8 = workbook.addWorksheet('EmergencyContact');
        const worksheet9 = workbook.addWorksheet('FamilyData');
        const worksheet10 = workbook.addWorksheet('EmployeeLeaves');
        const worksheet11 = workbook.addWorksheet('EmployeeStatus');

        const dataforlocationArr = await fetchDataForLocation();
        const dataforemploymentArr = await fetchDataForEmployment();
        const datafordepartmentArr = await fetchDataForDepartment();
        const dataforsectionArr = await fetchDataForSection();
        const dataforclassificationArr = await fetchDataForClassification();
        const dataforpaytypenArr = await fetchDataForPaytype();
        const dataforshiftscheduleArr = await fetchDataForShiftSchedule();
        const dataforpositionArr = await fetchDataForPosition();
        const dataforcompanyArr = await fetchDataForCompany();
        const salarytypesArr = fetchSalaryType;
        const dataforjobtitleArr = await fetchDataForJobTitle();
        const dataforemployeegroup1Arr = await fetchDataForEmployeeGroup1();
        const dataforemployeegroup2Arr = await fetchDataForEmployeeGroup2();
        const dataforplantilyaArr = await fetchDataForPlantilya();
        const dataforcostcenterArr = await fetchDataForCostCenter();
        const dataforclientArr = await fetchDataForClient();


        //EmployeePersonalInformation
        const headerEmployeePersonalInformation = [
            'EmployeeId',
            'LastName',
            'FirstName',
            'MiddleName',
            'ExtensionName',
            'NickName',
            'Age',
            'DateOfBirth',
            'PlaceOfBirth',
            'CivilStatus',
            'BloodType',
            'Height',
            'Weight',
            'Citizenship',
            'Religion',
            'Gender',
            'MobileNumber',
            'EmailAddress',
            'BlkLot',
            'Street',
            'Barangay',
            'City',
            'PostalCode',
            'YearsOfStay'
        ];
        const headerRowEmployeePersonalInformation = worksheet1.addRow(headerEmployeePersonalInformation);
        worksheet1.columns = [
            { key: 'employeeId', width: 30 },
            { key: 'lastName', width: 30 },
            { key: 'firstName', width: 30 },
            { key: 'middleName', width: 30 },
            { key: 'extensionName', width: 30 },
            { key: 'nickname', width: 20 },
            { key: 'age', width: 10 },
            { key: 'dateOfBirth', width: 20 },
            { key: 'placeOfBirth', width: 30 },
            { key: 'civilStatus', width: 20 },
            { key: 'bloodType', width: 10 },
            { key: 'height', width: 10 },
            { key: 'weight', width: 10 },
            { key: 'citizenship', width: 20 },
            { key: 'religion', width: 20 },
            { key: 'gender', width: 10 },
            { key: 'mobileNumber', width: 20 },
            { key: 'emailAddress', width: 30 },
            { key: 'blkLot', width: 20 },
            { key: 'street', width: 30 },
            { key: 'barangay', width: 20 },
            { key: 'city', width: 20 },
            { key: 'postalCode', width: 15 },
            { key: 'yearsOfStay', width: 15 },
        ];
        headerRowEmployeePersonalInformation.eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center' };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '92d050' },
            };
        });

        const employeeDataEmployeePersonalInformation = [
            {
                employeeId: '<EMP1234>',
                lastName: '<DELA CRUZ>',
                firstName: '<JUAN>',
                middleName: '<ANTONIO>',
                extensionName: '<OPTIONAL>',
                nickname: '<OPTIONAL>',
                age: '<30>',
                dateOfBirth: '<01/01/1993>',
                placeOfBirth: 'CALOOCAN CITY',
                civilStatus: 'SINGLE',
                bloodType: 'OPTIONAL',
                height: '<OPTIONAL>',
                weight: '<OPTIONAL>',
                citizenship: '<FILIPINO>',
                religion: '<ROMAN CATHOLIC>',
                gender: '<MALE>',
                mobileNumber: '<09123456789>',
                emailAddress: '<JUANDELACRUZ@GMAIL.COM>',
                blkLot: 'BLK 123 LOT 456',
                street: '<JUAN LUNA STREET>',
                barangay: 'DEPARO',
                city: 'CALOOCAN CITY',
                postalCode: '<1420>',
                yearsOfStay: '<5>'
            },
        ];

        employeeDataEmployeePersonalInformation.forEach(employee => {
            worksheet1.addRow(employee);
        });

        //EmployeeInformation
        const headerEmployeeInformation = [
            'EmployeeId',
            'Location',
            'DateEmployed',
            'DateRegular',
            'DateProbationary',
            'DateResigned',
            'DateContractual',
            'EmploymentDuration',
            'Employment',
            'Department',
            'Section',
            'Classification',
            'PayType',
            'ShiftSchedule',
            'Position',
            'Company',
            'SalaryType',
            'JobTitle',
            'EmployeeGroup1',
            'EmployeeGroup2',
            'Plantilya',
            'CostCenter',
            'Client',
        ];
        const headerRowEmployeeInformation = worksheet2.addRow(headerEmployeeInformation);
        worksheet2.columns = [
            { key: 'employeeId', width: 20 },
            { key: 'location', width: 30 },
            { key: 'dateEmployed', width: 20 },
            { key: 'dateRegular', width: 20 },
            { key: 'dateProbationary', width: 20 },
            { key: 'dateResigned', width: 20 },
            { key: 'dateContractual', width: 20 },
            { key: 'employmentDuration', width: 25 },
            { key: 'employment', width: 25 },
            { key: 'department', width: 30 },
            { key: 'section', width: 30 },
            { key: 'classification', width: 20 },
            { key: 'payType', width: 20 },
            { key: 'shiftSchedule', width: 20 },
            { key: 'position', width: 30 },
            { key: 'company', width: 30 },
            { key: 'salaryType', width: 30 },
            { key: 'jobTitle', width: 30 },
            { key: 'employeeGroup1', width: 30 },
            { key: 'employeeGroup2', width: 30 },
            { key: 'plantilya', width: 30 },
            { key: 'costCenter', width: 30 },
            { key: 'client', width: 30 },
        ];
        headerRowEmployeeInformation.eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center' };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '92d050' },
            };
        });

        const employeeDataEmployeeInformation = [
            {
                employeeId: '<EMP1234>',
                location: '<MAIN OFFICE>',
                dateEmployed: '<01-01-2021>',
                dateRegular: '<OPTIONAL>',
                dateProbationary: '<OPTIONAL>',
                dateResigned: '<OPTIONAL>',
                dateContractual: '<OPTIONAL>',
                employmentDuration: '<OPTIONAL>',
                employment: '<REGULAR>',
                department: '<IT>',
                section: '<SOFTWARE DEVELOPER>',
                classification: '<OFFICE>',
                payType: '<SEMI-MONTHLY>',
                shiftSchedule: '<MORNING SHIFT>',
                position: '<APPLICATION DEVELOPER>',
                company: '<COMPANY NAME>',
                salaryType: '<DAILY>',
                jobTitle: '<JOB TITLE>',
                employeeGroup1: '<EMPLOYEE GROUP 1>',
                employeeGroup2: '<EMPLOYEE GROUP 2>',
                plantilya: '<PLANTILYA>',
                costCenter: '<COST CENTER>',
                client: '<CLIENT>',
            }
        ];

        employeeDataEmployeeInformation.forEach(employee => {
          worksheet2.addRow(employee);
        });
        
        // -- Dropdown List for Excel ------------------------
        await addDropdownList(workbook, worksheet2, {
          column: 'B',
          startRow: 2,
          endRow: worksheet2.lastRow.number,
          listName: 'Location',
          data: dataforlocationArr.map(loc => loc.description),
        });
        await addDropdownList(workbook, worksheet2, {
          column: 'I',
          startRow: 2,
          endRow: worksheet2.lastRow.number,
          listName: 'Employment',
          data: dataforemploymentArr.map(loc => loc.description),
        });
        await addDropdownList(workbook, worksheet2, {
          column: 'J',
          startRow: 2,
          endRow: worksheet2.lastRow.number,
          listName: 'Department',
          data: datafordepartmentArr.map(loc => loc.description),
        });
        await addDropdownList(workbook, worksheet2, {
          column: 'K',
          startRow: 2,
          endRow: worksheet2.lastRow.number,
          listName: 'Section',
          data: dataforsectionArr.map(loc => loc.description),
        });
        await addDropdownList(workbook, worksheet2, {
          column: 'L',
          startRow: 2,
          endRow: worksheet2.lastRow.number,
          listName: 'Classification',
          data: dataforclassificationArr.map(loc => loc.description),
        });
        await addDropdownList(workbook, worksheet2, {
          column: 'M',
          startRow: 2,
          endRow: worksheet2.lastRow.number,
          listName: 'PayType',
          data: dataforpaytypenArr.map(loc => loc.description),
        });
        await addDropdownList(workbook, worksheet2, {
          column: 'N',
          startRow: 2,
          endRow: worksheet2.lastRow.number,
          listName: 'ShiftSchedule',
          data: dataforshiftscheduleArr.map(loc => loc.shiftName),
        });
        await addDropdownList(workbook, worksheet2, {
          column: 'O',
          startRow: 2,
          endRow: worksheet2.lastRow.number,
          listName: 'Position',
          data: dataforpositionArr.map(loc => loc.description),
        });
        await addDropdownList(workbook, worksheet2, {
          column: 'P',
          startRow: 2,
          endRow: worksheet2.lastRow.number,
          listName: 'Company',
          data: dataforcompanyArr.map(loc => loc.name),
        });
        await addDropdownList(workbook, worksheet2, {
          column: 'Q',
          startRow: 2,
          endRow: worksheet2.lastRow.number,
          listName: 'SalaryTypes',
          data: salarytypesArr,
        });
        await addDropdownList(workbook, worksheet2, {
          column: 'R',
          startRow: 2,
          endRow: worksheet2.lastRow.number,
          listName: 'JobTitle',
          data: dataforjobtitleArr.map(loc => loc.description),
        });
        await addDropdownList(workbook, worksheet2, {
          column: 'S',
          startRow: 2,
          endRow: worksheet2.lastRow.number,
          listName: 'EmployeeGroup1',
          data: dataforemployeegroup1Arr.map(loc => loc.description),
        });
        await addDropdownList(workbook, worksheet2, {
          column: 'T',
          startRow: 2,
          endRow: worksheet2.lastRow.number,
          listName: 'EmployeeGroup2',
          data: dataforemployeegroup2Arr.map(loc => loc.description),
        });
        await addDropdownList(workbook, worksheet2, {
          column: 'U',
          startRow: 2,
          endRow: worksheet2.lastRow.number,
          listName: 'Plantilya',
          data: dataforplantilyaArr.map(loc => loc.description),
        });
        await addDropdownList(workbook, worksheet2, {
          column: 'V',
          startRow: 2,
          endRow: worksheet2.lastRow.number,
          listName: 'CostCenter',
          data: dataforcostcenterArr.map(loc => loc.description),
        });
        await addDropdownList(workbook, worksheet2, {
          column: 'W',
          startRow: 2,
          endRow: worksheet2.lastRow.number,
          listName: 'Client',
          data: dataforclientArr.map(loc => loc.description),
        });
        // ----------------------------------------------------
        

        //AccountInformation
        const headerAccountInformation = [
            'EmployeeId',
            'Sss',
            'Tin',
            'Passport',
            'Philhealth',
            'Pagibig'
        ];
        const headerRowAccountInformation = worksheet3.addRow(headerAccountInformation);
        worksheet3.columns = [
            { key: 'employeeId', width: 30 },
            { key: 'sss', width: 30 },
            { key: 'tin', width: 30 },
            { key: 'passport', width: 30 },
            { key: 'philhealth', width: 30 },
            { key: 'pagibig', width: 30 },
        ];
        headerRowAccountInformation.eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center' };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '92d050' },
            };
        });

        const employeeDataAccountInformation = [
            {
                employeeId: '<EMP1234>',
                sss: '<00-00000000-0>',
                tin: '<000-000-000-000>',
                passport: '<OPTIONAL>',
                philhealth: '<00-000000000-0>',
                pagibig: '<0000-0000-0000>',
            }
        ];

        employeeDataAccountInformation.forEach(employee => {
            worksheet3.addRow(employee);
        });

        //BankAccount
        const headerBankAccount = [
            'EmployeeId',
            'BankAccount',
            'BankName'
        ];
        const headerRowBankAccount = worksheet4.addRow(headerBankAccount);
        worksheet4.columns = [
            { key: 'employeeId', width: 30 },
            { key: 'bankAccount', width: 30 },
            { key: 'bankName', width: 30 },
        ];
        headerRowBankAccount.eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center' };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '92d050' },
            };
        });

        const employeeDataBankAccount = [
            {
                employeeId: '<EMP1234>',
                bankAccount: '<0000000000000>',
                bankName: '<BPI>',
            }
        ];

        employeeDataBankAccount.forEach(employee => {
            worksheet4.addRow(employee);
        });

        //EmployeeSalary
        const headerEmployeeSalary = [
            'EmployeeId',
            'Salary',
            'Allowance'
        ];
        const headerRowEmployeeSalary = worksheet5.addRow(headerEmployeeSalary);
        worksheet5.columns = [
            { key: 'employeeId', width: 30 },
            { key: 'salary', width: 30 },
            { key: 'allowance', width: 30 },
        ];
        headerRowEmployeeSalary.eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center' };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '92d050' },
            };
        });

        const employeeDataEmployeeSalary = [
            {
                employeeId: '<EMP1234>',
                salary: '<#,##0.00>',
                allowance: '<#,##0.00>',
            }
        ];

        employeeDataEmployeeSalary.forEach(employee => {
            worksheet5.addRow(employee);
        });
        
        //Dependents
        const headerDependents = [
            'EmployeeId',
            'LastName',
            'FirstName',
            'MiddleName',
            'ExtensionName',
            'DateOfBirth',
            'Gender',
            'CivilStatus'
        ];
        const headerRowDependents = worksheet6.addRow(headerDependents);
        worksheet6.columns = [
            { key: 'employeeId', width: 30 },
            { key: 'lastName', width: 30 },
            { key: 'firstName', width: 30 },
            { key: 'middleName', width: 30 },
            { key: 'extensionName', width: 30 },
            { key: 'dateOfBirth', width: 20 },
            { key: 'gender', width: 20 },
            { key: 'civilStatus', width: 20 },
        ];
        headerRowDependents.eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center' };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '92d050' },
            };
        });

        const employeeDataDependents = [
            {
                employeeId: '<EMP1234>',
                lastName: '<DELA CRUZ>',
                firstName: '<JUNIOR>',
                middleName: '<ANTONIO>',
                extensionName: '<OPTIONAL>',
                dateOfBirth: '<01/01/2021>',
                gender: '<MALE>',
                civilStatus: '<SINGLE>',
            }
        ];

        employeeDataDependents.forEach(employee => {
            worksheet6.addRow(employee);
        });

        //EducationalAttainment
        const headerEducationalAttainment = [
            'EmployeeId',
            'Level',
            'SchoolName',
            'Address',
            'DateFrom',
            'DateTo',
            'Course',
            'Honors'
        ];
        const headerRowEducationalAttainment = worksheet7.addRow(headerEducationalAttainment);
        worksheet7.columns = [
            { key: 'employeeId', width: 30 },
            { key: 'level', width: 30 },
            { key: 'schoolName', width: 30 },
            { key: 'address', width: 30 },
            { key: 'dateFrom', width: 30 },
            { key: 'dateTo', width: 30 },
            { key: 'course', width: 30 },
            { key: 'honors', width: 30 },
        ];
        headerRowEducationalAttainment.eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center' };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '92d050' },
            };
        });

        const employeeDataEducationalAttainment = [
            {
                employeeId: '<EMP1234>',
                level: '<PRIMARY>',
                schoolName: '<UNIVERSITY OF THE PHILIPPINES>',
                address: '<QUEZON CITY>',
                dateFrom: '<01/01/2021>',
                dateTo: '<01/01/2021>',
                course: '<NONE>',
                honors: '<NONE>',
            }
        ];

        employeeDataEducationalAttainment.forEach(employee => {
            worksheet7.addRow(employee);
        });

        //EmergencyContact
        const headerEmergencyContact = [
            'EmployeeId',
            'Name',
            'Relationship',
            'ContactNumber',
            'Address'
        ];
        const headerRowEmergencyContact = worksheet8.addRow(headerEmergencyContact);
        worksheet8.columns = [
            { key: 'employeeId', width: 30 },
            { key: 'name', width: 30 },
            { key: 'relationship', width: 30 },
            { key: 'contactNumber', width: 30 },
            { key: 'address', width: 30 },
        ];
        headerRowEmergencyContact.eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center' };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '92d050' },
            };
        });

        const employeeDataEmergencyContact = [
            {
                employeeId: '<EMP1234>',
                name: '<DELA CRUZ, SPOUSE>',
                relationship: '<SPOUSE>',
                contactNumber: '<09123456789>',
                address: '<CALOOCAN CITY>',
            }
        ];

        employeeDataEmergencyContact.forEach(employee => {
            worksheet8.addRow(employee);
        });

        //FamilyData
        const headerFamilyData = [
            'EmployeeId',
            'Name',
            'DateOfBirth',
            'Occupation',
            'ContactNumber',
            'Age',
            'Address',
            'Relationship'
        ];
        const headerRowFamilyData = worksheet9.addRow(headerFamilyData);
        worksheet9.columns = [
            { key: 'employeeId', width: 30 },
            { key: 'name', width: 30 },
            { key: 'dateOfBirth', width: 30 },
            { key: 'occupation', width: 30 },
            { key: 'contactNumber', width: 30 },
            { key: 'age', width: 30 },
            { key: 'address', width: 20 },
            { key: 'relationship', width: 10 },
        ];
        headerRowFamilyData.eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center' };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '92d050' },
            };
        });

        const employeeDataFamilyData = [
            {
                employeeId: '<EMP1234>',
                name: '<DELA CRUZ, SPOUSE>',
                dateOfBirth: '<01/01/2021>',
                occupation: '<NONE>',
                contactNumber: '<09123456789>',
                age: '<25>',
                address: '<CALOOCAN CITY>',
                relationship: '<SPOUSE>',
            }
        ];

        employeeDataFamilyData.forEach(employee => {
            worksheet9.addRow(employee);
        });

        //EmployeeLeaves
        const headerEmployeeLeaves = [
            'EmployeeId',
            'VacationLeave',
            'SickLeave',
            'ServiceIncentiveLeave',
            'SoloParentLeave',
            'VacationLeaveRemaining',
            'SickLeaveRemaining',
            'ServiceIncentiveLeaveRemaining',
            'SoloParentLeaveRemaining',
        ];
        const headerRowEmployeeLeaves = worksheet10.addRow(headerEmployeeLeaves);
        worksheet10.columns = [
            { key: 'employeeId', width: 30 },
            { key: 'totalVacation', width: 30 },
            { key: 'totalSick', width: 30 },
            { key: 'totalServiceIncentive', width: 30 },
            { key: 'totalSoloParent', width: 30 },
            { key: 'vacationRemaining', width: 30 },
            { key: 'sickRemaining', width: 30 },
            { key: 'serviceIncentiveRemaining', width: 30 },
            { key: 'soloParentRemaining', width: 30 },
        ];
        headerRowEmployeeLeaves.eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center' };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '92d050' },
            };
        });

        const employeeDataEmployeeLeave = [
            {
                employeeId: '<EMP1234>',
                totalVacation: '<10.00>',
                totalSick: '<10.00>',
                totalServiceIncentive: '<10.00>',
                totalSoloParent: '<10.00>',
                vacationRemaining: '<10.00>',
                sickRemaining: '<10.00>',
                serviceIncentiveRemaining: '<10.00>',
                soloParentRemaining: '<10.00>',
            }
        ];

        employeeDataEmployeeLeave.forEach(employee => {
            worksheet10.addRow(employee);
        });

        //EmployeeStatus
        const headerEmployeeStatus = [
            'EmployeeId',
            'EmployeeStatus',
        ];
        const headerRowEmployeeStatus = worksheet11.addRow(headerEmployeeStatus);
        worksheet11.columns = [
            { key: 'employeeId', width: 30 },
            { key: 'status', width: 30 },
        ];
        headerRowEmployeeStatus.eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center' };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '92d050' },
            };
        });

        const employeeDataEmployeeStatus = [
            {
                employeeId: '<EMP1234>',
                status: '<Active>',
            }
        ];

        employeeDataEmployeeStatus.forEach(employee => {
            worksheet11.addRow(employee);
        });
    
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, 'Employee_Template.xlsx');
    }, [
        fetchDataForClassification, 
        fetchDataForCompany, 
        fetchDataForDepartment, 
        fetchDataForEmployment, 
        fetchDataForLocation, 
        fetchDataForPaytype, 
        fetchDataForPosition, 
        fetchDataForSection, 
        fetchDataForShiftSchedule, 
        fetchSalaryType, 
        fetchDataForClient,
        fetchDataForCostCenter,
        fetchDataForEmployeeGroup1,
        fetchDataForEmployeeGroup2,
        fetchDataForJobTitle,
        fetchDataForPlantilya,
    ]);
    const generateDownloadMasterlist = useCallback(async () => {
        setLoadingRequest(true);

        const _employees = await fetchDataEmployeeInfoForMasterlist();
        if(_employees && _employees.length <= 0){
            setLoadingRequest(false);
            setShowRequestMessage(true);
            setIsSuccess(false);
            setRequestMessage("Please wait for the _employees to load");
            return;
        }
    
        const workbook = new ExcelJS.Workbook();
        const worksheet1 = workbook.addWorksheet('EmployeePersonalInformation');
        const worksheet2 = workbook.addWorksheet('EmployeeInformation');
        const worksheet3 = workbook.addWorksheet('AccountInformation');
        const worksheet4 = workbook.addWorksheet('BankAccount');
        const worksheet5 = workbook.addWorksheet('EmployeeSalary');
        const worksheet6 = workbook.addWorksheet('Dependents');
        const worksheet7 = workbook.addWorksheet('EducationalAttainment');
        const worksheet8 = workbook.addWorksheet('EmergencyContact');
        const worksheet9 = workbook.addWorksheet('FamilyData');
        const worksheet10 = workbook.addWorksheet('EmployeeLeaves');
        const worksheet11 = workbook.addWorksheet('EmployeeStatus');
    
        function formatDate(dateString) {
            if(!dateString){
                return '';
            }
            const date = new Date(dateString);
            const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based in JavaScript
            const day = String(date.getDate()).padStart(2, '0');
            const year = date.getFullYear();
            return `${month}/${day}/${year}`;
        }
    
        //EmployeePersonalInformation
        const headerEmployeePersonalInformation = [
            'EmployeeId',
            'EmployeeName',
            'LastName',
            'FirstName',
            'MiddleName',
            'ExtensionName',
            'NickName',
            'Age',
            'DateOfBirth',
            'PlaceOfBirth',
            'CivilStatus',
            'BloodType',
            'Height',
            'Weight',
            'Citizenship',
            'Religion',
            'Gender',
            'MobileNumber',
            'EmailAddress',
            'BlkLot',
            'Street',
            'Barangay',
            'City',
            'PostalCode',
            'YearsOfStay'
        ];
        const headerRowEmployeePersonalInformation = worksheet1.addRow(headerEmployeePersonalInformation);
        worksheet1.columns = [
            { key: 'employeeId', width: 30 },
            { key: 'fullName', width: 30 },
            { key: 'lastName', width: 30 },
            { key: 'firstName', width: 30 },
            { key: 'middleName', width: 30 },
            { key: 'extensionName', width: 30 },
            { key: 'nickname', width: 20 },
            { key: 'age', width: 10 },
            { key: 'dateOfBirth', width: 20 },
            { key: 'placeOfBirth', width: 30 },
            { key: 'civilStatus', width: 20 },
            { key: 'bloodType', width: 10 },
            { key: 'height', width: 10 },
            { key: 'weight', width: 10 },
            { key: 'citizenship', width: 20 },
            { key: 'religion', width: 20 },
            { key: 'gender', width: 10 },
            { key: 'mobileNumber', width: 20 },
            { key: 'emailAddress', width: 30 },
            { key: 'blkLot', width: 20 },
            { key: 'street', width: 30 },
            { key: 'barangay', width: 20 },
            { key: 'city', width: 20 },
            { key: 'postalCode', width: 15 },
            { key: 'yearsOfStay', width: 15 },
        ];
        headerRowEmployeePersonalInformation.eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center' };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '92d050' },
            };
        });
    
        _employees.forEach((item) => {
            worksheet1.addRow([
                item.employeeId,
                item.fullName,
                item.lastName,
                item.firstName,
                item.middleName,
                item.extensionName,
                item.nickName,
                item.age,
                formatDate(item.dateOfBirth),
                item.placeOfBirth,
                item.civilStatus,
                item.bloodType,
                item.height,
                item.weight,
                item.citizenship,
                item.religion,
                item.gender,
                item.mobileNumber,
                item.emailAddress,
                item.blkLot,
                item.street,
                item.barangay,
                item.city,
                item.postalCode,
                item.yearsOfStay
            ]);
        });
    
        //EmployeeInformation
        const headerEmployeeInformation = [
            'EmployeeId',
            'EmployeeName',
            'Location',
            'DateEmployed',
            'DateRegular',
            'DateProbationary',
            'DateResigned',
            'DateContractual',
            'EmploymentDuration',
            'Employment',
            'Department',
            'Section',
            'Classification',
            'PayType',
            'ShiftSchedule',
            'Position',
            'Company',
            'SalaryType',
            'JobTitle',
            'EmployeeGroup1',
            'EmployeeGroup2',
            'Plantilya',
            'CostCenter',
            'Client',
        ];
        const headerRowEmployeeInformation = worksheet2.addRow(headerEmployeeInformation);
        worksheet2.columns = [
            { key: 'employeeId', width: 20 },
            { key: 'fullName', width: 20 },
            { key: 'location', width: 30 },
            { key: 'dateEmployed', width: 20 },
            { key: 'dateRegular', width: 20 },
            { key: 'dateProbationary', width: 20 },
            { key: 'dateResigned', width: 20 },
            { key: 'dateContractual', width: 20 },
            { key: 'employmentDuration', width: 25 },
            { key: 'employment', width: 25 },
            { key: 'department', width: 30 },
            { key: 'section', width: 30 },
            { key: 'classification', width: 20 },
            { key: 'payType', width: 20 },
            { key: 'shiftSchedule', width: 20 },
            { key: 'position', width: 30 },
            { key: 'company', width: 30 },
            { key: 'salaryType', width: 30 },
            { key: 'jobtitle', width: 30 },
            { key: 'employeeGroup1', width: 30 },
            { key: 'employeeGroup2', width: 30 },
            { key: 'plantilya', width: 30 },
            { key: 'costcenter', width: 30 },
            { key: 'client', width: 30 },
        ];
        headerRowEmployeeInformation.eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center' };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '92d050' },
            };
        });
    
        // console.log(_employees)
    
        _employees.forEach(item => {
            if(item.employeeInformation){
                worksheet2.addRow([
                    item.employeeId,
                    item.fullName,
                    item.employeeInformation.locationDescription ? item.employeeInformation.locationDescription : "",
                    item.employeeInformation.dateEmployed ? item.employeeInformation.dateEmployed : "",
                    item.employeeInformation.dateRegular ? item.employeeInformation.dateRegular : "",
                    item.employeeInformation.dateProbationary ? item.employeeInformation.dateProbationary : "",
                    item.employeeInformation.dateResigned ? item.employeeInformation.dateResigned : "",
                    item.employeeInformation.dateContractual ? item.employeeInformation.dateContractual : "",
                    item.employeeInformation.employmentDuration ? item.employeeInformation.employmentDuration : "",
                    item.employeeInformation.employmentDescription ? item.employeeInformation.employmentDescription : "",
                    item.employeeInformation.departmentDescription ? item.employeeInformation.departmentDescription : "",
                    item.employeeInformation.sectionDescription ? item.employeeInformation.sectionDescription : "",
                    item.employeeInformation.classificationDescription ? item.employeeInformation.classificationDescription : "",
                    item.employeeInformation.payTypeDescription ? item.employeeInformation.payTypeDescription : "",
                    item.employeeInformation.shiftScheduleShiftName ? item.employeeInformation.shiftScheduleShiftName : "",
                    item.employeeInformation.positionDescription ? item.employeeInformation.positionDescription : "",
                    item.employeeInformation.companyName ? item.employeeInformation.companyName : "",
                    item.employeeInformation.salaryType ? item.employeeInformation.salaryType : "",
                    item.employeeInformation.jobTitleDescription ? item.employeeInformation.jobTitleDescription : "",
                    item.employeeInformation.employeeGroup1Description ? item.employeeInformation.employeeGroup1Description : "",
                    item.employeeInformation.employeeGroup2Description ? item.employeeInformation.employeeGroup2Description : "",
                    item.employeeInformation.plantilyaDescription ? item.employeeInformation.plantilyaDescription : "",
                    item.employeeInformation.costCenterDescription ? item.employeeInformation.costCenterDescription : "",
                    item.employeeInformation.clientDescription ? item.employeeInformation.clientDescription : "",
                ]);
            }
            else{
                worksheet2.addRow([item.employeeId, item.fullName]);
            }
        });
    
        //AccountInformation
        const headerAccountInformation = [
            'EmployeeId',
            'EmployeeName',
            'Sss',
            'Tin',
            'Passport',
            'Philhealth',
            'Pagibig'
        ];
        const headerRowAccountInformation = worksheet3.addRow(headerAccountInformation);
        worksheet3.columns = [
            { key: 'employeeId', width: 30 },
            { key: 'fullName', width: 30 },
            { key: 'sss', width: 30 },
            { key: 'tin', width: 30 },
            { key: 'passport', width: 30 },
            { key: 'philhealth', width: 30 },
            { key: 'pagibig', width: 30 },
        ];
        headerRowAccountInformation.eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center' };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '92d050' },
            };
        });
    
        _employees.forEach(item => {
            if(item.employeeAccountInformation){
                worksheet3.addRow([
                    item.employeeId,
                    item.fullName,
                    item.employeeAccountInformation.sss ? item.employeeAccountInformation.sss : "",
                    item.employeeAccountInformation.tin ? item.employeeAccountInformation.tin : "",
                    item.employeeAccountInformation.passport ? item.employeeAccountInformation.passport : "",
                    item.employeeAccountInformation.philhealth ? item.employeeAccountInformation.philhealth : "",
                    item.employeeAccountInformation.pagibig ? item.employeeAccountInformation.pagibig : "",
                ]);
            }
            else{
                worksheet3.addRow([item.employeeId, item.fullName]);
            }
        });
    
        //BankAccount
        const headerBankAccount = [
            'EmployeeId',
            'EmployeeName',
            'BankAccount',
            'BankName'
        ];
        const headerRowBankAccount = worksheet4.addRow(headerBankAccount);
        worksheet4.columns = [
            { key: 'employeeId', width: 30 },
            { key: 'fullName', width: 30 },
            { key: 'bankAccount', width: 30 },
            { key: 'bankName', width: 30 },
        ];
        headerRowBankAccount.eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center' };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '92d050' },
            };
        });
    
        _employees.forEach(item => {
            if (item.employeeBankAccount && item.employeeBankAccount.length > 0) {
                item.employeeBankAccount.forEach(account => {
                    worksheet4.addRow([
                        item.employeeId,
                        item.fullName,
                        account.bankAccount ? account.bankAccount : "",
                        account.bankName ? account.bankName : ""
                    ]);
                });
            } else {
                worksheet4.addRow([item.employeeId, item.fullName]);
            }
        });
    
        //EmployeeSalary
        const headerEmployeeSalary = [
            'EmployeeId',
            'EmployeeName',
            'Salary',
            'Allowance'
        ];
        const headerRowEmployeeSalary = worksheet5.addRow(headerEmployeeSalary);
        worksheet5.columns = [
            { key: 'employeeId', width: 30 },
            { key: 'fullName', width: 30 },
            { key: 'salary', width: 30 },
            { key: 'allowance', width: 30 },
        ];
        headerRowEmployeeSalary.eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center' };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '92d050' },
            };
        });
    
        _employees.forEach(item => {
            if(item.employeeSalary){
                worksheet5.addRow([
                    item.employeeId,
                    item.fullName,
                    item.employeeSalary.salary ? item.employeeSalary.salary : "",
                    item.employeeSalary.allowance ? item.employeeSalary.allowance : "",
                ]);
            } else {
                worksheet5.addRow([item.employeeId, item.fullName]);
            }
        });
        
        //Dependents
        const headerDependents = [
            'EmployeeId',
            'EmployeeName',
            'LastName',
            'FirstName',
            'MiddleName',
            'ExtensionName',
            'DateOfBirth',
            'Gender',
            'CivilStatus'
        ];
        const headerRowDependents = worksheet6.addRow(headerDependents);
        worksheet6.columns = [
            { key: 'employeeId', width: 30 },
            { key: 'fullName', width: 30 },
            { key: 'lastName', width: 30 },
            { key: 'firstName', width: 30 },
            { key: 'middleName', width: 30 },
            { key: 'extensionName', width: 30 },
            { key: 'dateOfBirth', width: 20 },
            { key: 'gender', width: 20 },
            { key: 'civilStatus', width: 20 },
        ];
        headerRowDependents.eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center' };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '92d050' },
            };
        });
    
        _employees.forEach(item => {
            if (item.employeeDependents && item.employeeDependents.length > 0) {
                item.employeeDependents.forEach(dependent => {
                    worksheet6.addRow([
                        item.employeeId,
                        item.fullName,
                        dependent.lastName ? dependent.lastName : "",
                        dependent.firstName ? dependent.firstName : "",
                        dependent.middleName ? dependent.middleName : "",
                        dependent.extensionName ? dependent.extensionName : "",
                        dependent.dateOfBirth ? formatDate(dependent.dateOfBirth) : "",
                        dependent.gender ? dependent.gender : "",
                        dependent.civilStatus ? dependent.civilStatus : ""
                    ]);
                });
            } else {
                worksheet6.addRow([item.employeeId, item.fullName]);
            }
        });
    
        //EducationalAttainment
        const headerEducationalAttainment = [
            'EmployeeId',
            'EmployeeName',
            'Level',
            'SchoolName',
            'Address',
            'DateFrom',
            'DateTo',
            'Course',
            'Honors'
        ];
        const headerRowEducationalAttainment = worksheet7.addRow(headerEducationalAttainment);
        worksheet7.columns = [
            { key: 'employeeId', width: 30 },
            { key: 'fullName', width: 30 },
            { key: 'level', width: 30 },
            { key: 'schoolName', width: 30 },
            { key: 'address', width: 30 },
            { key: 'dateFrom', width: 30 },
            { key: 'dateTo', width: 30 },
            { key: 'course', width: 30 },
            { key: 'honors', width: 30 },
        ];
        headerRowEducationalAttainment.eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center' };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '92d050' },
            };
        });
    
        _employees.forEach(item => {
            if (item.employeeEducationAttainments && item.employeeEducationAttainments.length > 0) {
                item.employeeEducationAttainments.forEach(data => {
                    worksheet7.addRow([
                        item.employeeId,
                        item.fullName,
                        data.level ? data.level : "",
                        data.schoolName ? data.schoolName : "",
                        data.address ? data.address : "",
                        data.dateFrom ? formatDate(data.dateFrom) : "",
                        data.dateTo ? formatDate(data.dateTo) : "",
                        data.course ? data.course : "",
                        data.honors ? data.honors : "",
                    ]);
                });
            } else {
                worksheet7.addRow([item.employeeId, item.fullName]);
            }
        });
    
        //EmergencyContact
        const headerEmergencyContact = [
            'EmployeeId',
            'EmployeeName',
            'Name',
            'Relationship',
            'ContactNumber',
            'Address'
        ];
        const headerRowEmergencyContact = worksheet8.addRow(headerEmergencyContact);
        worksheet8.columns = [
            { key: 'employeeId', width: 30 },
            { key: 'fullName', width: 30 },
            { key: 'name', width: 30 },
            { key: 'relationship', width: 30 },
            { key: 'contactNumber', width: 30 },
            { key: 'address', width: 30 },
        ];
        headerRowEmergencyContact.eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center' };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '92d050' },
            };
        });
    
        _employees.forEach(item => {
            if (item.employeeEmergencyContacts && item.employeeEmergencyContacts.length > 0) {
                item.employeeEmergencyContacts.forEach(data => {
                    worksheet8.addRow([
                        item.employeeId,
                        item.fullName,
                        data.name ? data.name : "",
                        data.relationship ? data.relationship : "",
                        data.contactNumber ? data.contactNumber : "",
                        data.address ? data.address : "",
                    ]);
                });
            } else {
                worksheet8.addRow([item.employeeId, item.fullName]);
            }
        });
    
        //FamilyData
        const headerFamilyData = [
            'EmployeeId',
            'EmployeeName',
            'Name',
            'DateOfBirth',
            'Occupation',
            'ContactNumber',
            'Age',
            'Address',
            'Relationship'
        ];
        const headerRowFamilyData = worksheet9.addRow(headerFamilyData);
        worksheet9.columns = [
            { key: 'employeeId', width: 30 },
            { key: 'fullName', width: 30 },
            { key: 'name', width: 30 },
            { key: 'dateOfBirth', width: 30 },
            { key: 'occupation', width: 30 },
            { key: 'contactNumber', width: 30 },
            { key: 'age', width: 30 },
            { key: 'address', width: 20 },
            { key: 'relationship', width: 20 },
        ];
        headerRowFamilyData.eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center' };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '92d050' },
            };
        });
    
        _employees.forEach(item => {
            if (item.employeeFamilyData && item.employeeFamilyData.length > 0) {
                item.employeeFamilyData.forEach(data => {
                    worksheet9.addRow([
                        item.employeeId,
                        item.fullName,
                        data.name ? data.name : "",
                        data.dateOfBirth ? formatDate(data.dateOfBirth) : "",
                        data.occupation ? data.occupation : "",
                        data.contactNumber ? data.contactNumber : "",
                        data.age ? data.age : "",
                        data.address ? data.address : "",
                        data.relationship ? data.relationship : "",
                    ]);
                });
            } else {
                worksheet9.addRow([item.employeeId, item.fullName]);
            }
        });
    
        //EmployeeLeave
        const headerEmployeeLeaves = [
            'EmployeeId',
            'EmployeeName',
            'VacationLeave',
            'SickLeave',
            'ServiceIncentiveLeave',
            'SoloParentLeave',
            'VacationLeaveRemaining',
            'SickLeaveRemaining',
            'ServiceIncentiveLeaveRemaining',
            'SoloParentLeaveRemaining',
        ];
        const headerRowEmployeeLeaves = worksheet10.addRow(headerEmployeeLeaves);
        worksheet10.columns = [
            { key: 'employeeId', width: 30 },
            { key: 'fullName', width: 30 },
            { key: 'totalVacation', width: 30 },
            { key: 'totalSick', width: 30 },
            { key: 'totalServiceIncentive', width: 30 },
            { key: 'totalSoloParent', width: 30 },
            { key: 'vacationRemaining', width: 30 },
            { key: 'sickRemaining', width: 30 },
            { key: 'serviceIncentiveRemaining', width: 30 },
            { key: 'soloParentRemaining', width: 30 },
        ];
        headerRowEmployeeLeaves.eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center' };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '92d050' },
            };
        });
    
        _employees.forEach(item => {
            if(item.employeeLeave){
                worksheet10.addRow([
                    item.employeeId,
                    item.fullName,
                    item.employeeLeave.totalVacation ? item.employeeLeave.totalVacation : "",
                    item.employeeLeave.totalSick ? item.employeeLeave.totalSick : "",
                    item.employeeLeave.totalServiceIncentive ? item.employeeLeave.totalServiceIncentive : "",
                    item.employeeLeave.totalSoloParent ? item.employeeLeave.totalSoloParent : "",
                    item.employeeLeave.vacationRemaining ? item.employeeLeave.vacationRemaining : "",
                    item.employeeLeave.sickRemaining ? item.employeeLeave.sickRemaining : "",
                    item.employeeLeave.serviceIncentiveRemaining ? item.employeeLeave.serviceIncentiveRemaining : "",
                    item.employeeLeave.soloParentRemaining ? item.employeeLeave.soloParentRemaining : "",
                ]);
            }
            else{
                worksheet10.addRow([item.employeeId, item.fullName]);
            }
        });
    
        //EmployeeStatuses
        const headerEmployeeStatuses = [
            'EmployeeId',
            'EmployeeName',
            'EmployeeStatus',
        ];
        const headerRowEmployeeStatuses = worksheet11.addRow(headerEmployeeStatuses);
        worksheet11.columns = [
            { key: 'employeeId', width: 30 },
            { key: 'fullName', width: 30 },
            { key: 'status', width: 30 },
        ];
        headerRowEmployeeStatuses.eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center' };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '92d050' },
            };
        });
    
        _employees.forEach(item => {
            if(item.employeeStatuses){
                worksheet11.addRow([
                    item.employeeId,
                    item.fullName,
                    item.employeeStatuses.status ? item.employeeStatuses.status : "",
                ]);
            }
            else{
                worksheet11.addRow([item.employeeId, item.fullName]);
            }
        });

        setLoadingRequest(false);
    
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, 'Masterlist.xlsx');
    }, [fetchDataEmployeeInfoForMasterlist]);
    const generateDownloadForBulkUpdateTemplate = useCallback(async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('EmployeeInformation');

        // -- Added dropdown
        const dataforlocationArr = await fetchDataForLocation();
        const dataforsectionArr = await fetchDataForSection();
        const dataforpositionArr = await fetchDataForPosition();
        const datafordepartmentArr = await fetchDataForDepartment();
        const salarytypesArr = fetchSalaryType;
        const dataforpaytypeArr = await fetchDataForPaytype();
        const dataforshiftscheduleArr = await fetchDataForShiftSchedule();
        const dataforclassificationArr = await fetchDataForClassification();

        // -- new columns with dropdown
        const dataforcompanyArr = await fetchDataForCompany();
        const dataforjobtitleArr = await fetchDataForJobTitle();
        const dataforemployeegroup1Arr = await fetchDataForEmployeeGroup1();
        const dataforemployeegroup2Arr = await fetchDataForEmployeeGroup2();
        const dataforplantilyaArr = await fetchDataForPlantilya();
        const dataforcostcenterArr = await fetchDataForCostCenter();
        const dataforclientArr = await fetchDataForClient();

    
        const header = [
          'EmployeeId', 
          'EmployeeName', 
          'Location', 
          'Section', 
          'Position', 
          'Department', 
          'SalaryType', 
          'PayType', 
          'ShiftSchedule', 
          'Classification',
          'Company', // --- new columns
          'JobTitle',
          'EmployeeGroup1',
          'EmployeeGroup2',
          'Plantilya',
          'CostCenter',
          'Client',
        ];
        const headerRow = worksheet.addRow(header);
    
        worksheet.columns = [
            { key: 'employeeId', width: 25 },
            { key: 'employeeName', width: 30 },
            { key: 'location', width: 25 },
            { key: 'section', width: 25 },
            { key: 'position', width: 25 },
            { key: 'department', width: 25 },
            { key: 'salaryType', width: 25 },
            { key: 'payType', width: 25 },
            { key: 'shiftSchedule', width: 25 },
            { key: 'classification', width: 25 },
            { key: 'company', width: 30 },
            { key: 'jobTitle', width: 30 },
            { key: 'employeeGroup1', width: 30 },
            { key: 'employeeGroup2', width: 30 },
            { key: 'plantilya', width: 30 },
            { key: 'costCenter', width: 30 },
            { key: 'client', width: 30 },
        ];
    
        headerRow.eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center' };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '92d050' },
            };
        });
    
        const employeeTemplate = [
            {
                employeeId: '<EMP1234>',
                employeeName: '<DELA CRUZ, JUAN>',
                location: '<MAIN OFFICE>',
                section: '<MAIN OFFICE>',
                position: '<MARKETING ASSISTANT>',
                department: '<WAREHOUSE>',
                salaryType: '<POSITION - DESIGNATION>',
                payType: '<WEEKLY>',
                shiftSchedule: '<MORNING SHIFT>',
                classification: '<MONTHLY>',
                company: '<COMPANY NAME>', // -- new fields
                jobTitle: '<JOB TITLE>',
                employeeGroup1: '<EMPLOYEE GROUP 1>',
                employeeGroup2: '<EMPLOYEE GROUP 2>',
                plantilya: '<PLANTILYA>',
                costCenter: '<COST CENTER>',
                client: '<CLIENT>',
            },
        ];

        employeeTemplate.forEach(info => {
            worksheet.addRow(info);
        });

        // -- Dropdown List for Excel ------------------------
        await addDropdownList(workbook, worksheet, {
          column: 'C',
          startRow: 2,
          endRow: worksheet.lastRow.number,
          listName: 'Location',
          data: dataforlocationArr.map(loc => loc.description),
        });
        await addDropdownList(workbook, worksheet, {
          column: 'D',
          startRow: 2,
          endRow: worksheet.lastRow.number,
          listName: 'Section',
          data: dataforsectionArr.map(loc => loc.description),
        });
        await addDropdownList(workbook, worksheet, {
          column: 'E',
          startRow: 2,
          endRow: worksheet.lastRow.number,
          listName: 'Position',
          data: dataforpositionArr.map(loc => loc.description),
        });
        await addDropdownList(workbook, worksheet, {
          column: 'F',
          startRow: 2,
          endRow: worksheet.lastRow.number,
          listName: 'Department',
          data: datafordepartmentArr.map(loc => loc.description),
        });
        await addDropdownList(workbook, worksheet, {
          column: 'G',
          startRow: 2,
          endRow: worksheet.lastRow.number,
          listName: 'SalaryType',
          data: salarytypesArr,
        });
        await addDropdownList(workbook, worksheet, {
          column: 'H',
          startRow: 2,
          endRow: worksheet.lastRow.number,
          listName: 'PayType',
          data: dataforpaytypeArr.map(loc => loc.description),
        });
        await addDropdownList(workbook, worksheet, {
          column: 'I',
          startRow: 2,
          endRow: worksheet.lastRow.number,
          listName: 'ShiftSchedule',
          data: dataforshiftscheduleArr.map(loc => loc.shiftName),
        });
        await addDropdownList(workbook, worksheet, {
          column: 'J',
          startRow: 2,
          endRow: worksheet.lastRow.number,
          listName: 'Classification',
          data: dataforclassificationArr.map(loc => loc.description),
        });

        await addDropdownList(workbook, worksheet, {
          column: 'K',
          startRow: 2,
          endRow: worksheet.lastRow.number,
          listName: 'Company',
          data: dataforcompanyArr.map(loc => loc.name),
        });
        await addDropdownList(workbook, worksheet, {
          column: 'L',
          startRow: 2,
          endRow: worksheet.lastRow.number,
          listName: 'JobTitle',
          data: dataforjobtitleArr.map(loc => loc.description),
        });
        await addDropdownList(workbook, worksheet, {
          column: 'M',
          startRow: 2,
          endRow: worksheet.lastRow.number,
          listName: 'EmployeeGroup1',
          data: dataforemployeegroup1Arr.map(loc => loc.description),
        });
        await addDropdownList(workbook, worksheet, {
          column: 'N',
          startRow: 2,
          endRow: worksheet.lastRow.number,
          listName: 'EmployeeGroup2',
          data: dataforemployeegroup2Arr.map(loc => loc.description),
        });
        await addDropdownList(workbook, worksheet, {
          column: 'O',
          startRow: 2,
          endRow: worksheet.lastRow.number,
          listName: 'Plantilya',
          data: dataforplantilyaArr.map(loc => loc.description),
        });
        await addDropdownList(workbook, worksheet, {
          column: 'P',
          startRow: 2,
          endRow: worksheet.lastRow.number,
          listName: 'CostCenter',
          data: dataforcostcenterArr.map(loc => loc.description),
        });
        await addDropdownList(workbook, worksheet, {
          column: 'Q',
          startRow: 2,
          endRow: worksheet.lastRow.number,
          listName: 'Client',
          data: dataforclientArr.map(loc => loc.description),
        });

    
        setLoading(false);
    
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, 'Employee_Information_Template.xlsx');
    }, [
        fetchDataForClassification,
        fetchDataForClient,
        fetchDataForCompany,
        fetchDataForCostCenter,
        fetchDataForDepartment,
        fetchDataForEmployeeGroup1,
        fetchDataForEmployeeGroup2,
        fetchDataForJobTitle,
        fetchDataForLocation,
        fetchDataForPaytype,
        fetchDataForPlantilya,
        fetchDataForPosition,
        fetchDataForSection,
        fetchDataForShiftSchedule,
        fetchSalaryType,
    ]);
    const generateDownloadRemainingLeave = useCallback(async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('EmployeeLeave');

        if(employees.length <= 0){
            setLoadingRequest(false);
            setShowRequestMessage(true);
            setIsSuccess(false);
            setRequestMessage("No employees to download.");
            return;
        }
    
        const header = ['EmployeeId', 
            'EmployeeName', 
            'VacationLeave', 
            'SickLeave', 
            'ServiceIncentiveLeave', 
            'SoloParentLeave',
            'VacationLeaveRemaining',
            'SickLeaveRemaining',
            'ServiceIncentiveLeaveRemaining',
            'SoloParentLeaveRemaining',
        ];
        const headerRow = worksheet.addRow(header);
    
        worksheet.columns = [
            { key: 'employeeId', width: 25 },
            { key: 'employeeName', width: 30 },
            { key: 'totalVacation', width: 30 },
            { key: 'totalSick', width: 30 },
            { key: 'totalServiceIncentive', width: 30 },
            { key: 'totalSoloParent', width: 30 },
            { key: 'vacationRemaining', width: 30 },
            { key: 'sickRemaining', width: 30 },
            { key: 'serviceIncentiveRemaining', width: 30 },
            { key: 'soloParentRemaining', width: 30 },
        ];
    
        headerRow.eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center' };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '92d050' },
            };
        });

        const _activeEmployees = employees.filter(i => i.status === "Active");
    
        _activeEmployees
            .slice() // prevents mutating original array
            .sort((a, b) =>
                (a.fullName ?? "").localeCompare(b.fullName ?? "", undefined, {
                sensitivity: "base"
                })
            )
            .forEach(item => {
                worksheet.addRow({
                employeeId: item.employeeId ?? "",
                employeeName: item.fullName ?? "",
                totalVacation: item.employeeLeave?.totalVacation?.toString() ?? "0",
                totalSick: item.employeeLeave?.totalSick?.toString() ?? "0",
                totalServiceIncentive: item.employeeLeave?.totalServiceIncentive?.toString() ?? "0",
                totalSoloParent: item.employeeLeave?.totalSoloParent?.toString() ?? "0",
                vacationRemaining: item.employeeLeave?.vacationRemaining?.toString() ?? "0",
                sickRemaining: item.employeeLeave?.sickRemaining?.toString() ?? "0",
                serviceIncentiveRemaining: item.employeeLeave?.serviceIncentiveRemaining?.toString() ?? "0",
                soloParentRemaining: item.employeeLeave?.soloParentRemaining?.toString() ?? "0",
                });
        });
    
        setLoading(false);
    
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, 'Employee_Leave.xlsx');
    }, [employees]);
    const generateDownloadLeaveTemplate = useCallback(async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('EmployeeLeave');
    
        const header = ['EmployeeId', 
            'EmployeeName', 
            'VacationLeave', 
            'SickLeave', 
            'ServiceIncentiveLeave', 
            'SoloParentLeave',
            'VacationLeaveRemaining',
            'SickLeaveRemaining',
            'ServiceIncentiveLeaveRemaining',
            'SoloParentLeaveRemaining',
            ];
        const headerRow = worksheet.addRow(header);
    
        worksheet.columns = [
            { key: 'employeeId', width: 25 },
            { key: 'employeeName', width: 30 },
            { key: 'totalVacation', width: 30 },
            { key: 'totalSick', width: 30 },
            { key: 'totalServiceIncentive', width: 30 },
            { key: 'totalSoloParent', width: 30 },
            { key: 'vacationRemaining', width: 30 },
            { key: 'sickRemaining', width: 30 },
            { key: 'serviceIncentiveRemaining', width: 30 },
            { key: 'soloParentRemaining', width: 30 },
        ];
    
        headerRow.eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center' };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '92d050' },
            };
        });
    
        const employeeTemplate = [
            {
                employeeId: '<EMP1234>',
                employeeName: '<DELA CRUZ, JUAN>',
                totalVacation: '<10.00>',
                totalSick: '<10.00>',
                totalServiceIncentive: '<10.00>',
                totalSoloParent: '<10.00>',
                vacationRemaining: '<10.00>',
                sickRemaining: '<10.00>',
                serviceIncentiveRemaining: '<10.00>',
                soloParentRemaining: '<10.00>',
            },
        ];

        employeeTemplate.forEach(info => {
            worksheet.addRow(info);
        });
    
        setLoading(false);
    
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, 'Employee_Leave_Template.xlsx');
    }, []);
    const generateDownloadEmployeeInformation = useCallback(async () => {
        setLoadingRequest(true);

        const _employees = await fetchDataEmployeeInformationOnly();
        if(_employees && _employees.length <= 0){
            setLoadingRequest(false);
            setShowRequestMessage(true);
            setIsSuccess(false);
            setRequestMessage("Please wait for the _employees to load");
            return;
        }
    
        const workbook = new ExcelJS.Workbook();
        const worksheet2 = workbook.addWorksheet('EmployeeInformation');
    
        //EmployeeInformation
        const headerEmployeeInformation = [
            'EmployeeId',
            'EmployeeName',
            'Location',
            'Employment',
            'Department',
            'Section',
            'Classification',
            'PayType',
            'ShiftSchedule',
            'Position',
            'SalaryType',
            'JobTitle',
            'EmployeeGroup1',
            'EmployeeGroup2',
            'Plantilya',
            'CostCenter',
            'Client',
        ];
        const headerRowEmployeeInformation = worksheet2.addRow(headerEmployeeInformation);
        worksheet2.columns = [
            { key: 'employeeId', width: 20 },
            { key: 'employeeName', width: 30 },
            { key: 'location', width: 20 },
            { key: 'employment', width: 20 },
            { key: 'department', width: 20 },
            { key: 'section', width: 20 },
            { key: 'classification', width: 20 },
            { key: 'payType', width: 20 },
            { key: 'shiftSchedule', width: 20 },
            { key: 'position', width: 20 },
            { key: 'salaryType', width: 20 },
            { key: 'jobTitle', width: 20 },
            { key: 'employeeGroup1', width: 20 },
            { key: 'employeeGroup2', width: 20 },
            { key: 'plantilya', width: 20 },
            { key: 'costCenter', width: 20 },
            { key: 'client', width: 20 },
        ];
        headerRowEmployeeInformation.eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center' };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '92d050' },
            };
        });
    
        _employees.forEach(item => {
            if(item.employeeInformation){
                worksheet2.addRow([
                    item.employeeId,
                    item.fullName,
                    item.employeeInformation.locationDescription ? item.employeeInformation.locationDescription : "",
                    item.employeeInformation.employmentDescription ? item.employeeInformation.employmentDescription : "",
                    item.employeeInformation.departmentDescription ? item.employeeInformation.departmentDescription : "",
                    item.employeeInformation.sectionDescription ? item.employeeInformation.sectionDescription : "",
                    item.employeeInformation.classificationDescription ? item.employeeInformation.classificationDescription : "",
                    item.employeeInformation.payTypeDescription ? item.employeeInformation.payTypeDescription : "",
                    item.employeeInformation.shiftScheduleShiftName ? item.employeeInformation.shiftScheduleShiftName : "",
                    item.employeeInformation.positionDescription ? item.employeeInformation.positionDescription : "",
                    item.employeeInformation.salaryType ? item.employeeInformation.salaryType : "",
                    item.employeeInformation.jobTitleDescription ? item.employeeInformation.jobTitleDescription : "",
                    item.employeeInformation.employeeGroup1Description ? item.employeeInformation.employeeGroup1Description : "",
                    item.employeeInformation.employeeGroup2Description ? item.employeeInformation.employeeGroup2Description : "",
                    item.employeeInformation.plantilyaDescription ? item.employeeInformation.plantilyaDescription : "",
                    item.employeeInformation.costCenterDescription ? item.employeeInformation.costCenterDescription : "",
                    item.employeeInformation.clientDescription ? item.employeeInformation.clientDescription : "",
                ]);
            }
            else{
                worksheet2.addRow([item.employeeId]);
            }
        });
    
        setLoadingRequest(false);
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, 'Employee_Information.xlsx');
    }, [fetchDataEmployeeInformationOnly]);

    const createAccountBulk = async (bulkData) => {
        const accessTemplate = await fetchDataAccessTemplate();
        const accounts = await fetchDataAccounts();
        const employeeInfo = await fetchDataEmployeeInfoForMasterlist();

        const foundTemplate = accessTemplate.find(data => 
            data.description.toLowerCase() === ("Employee").toLowerCase()
        );

        function generateUniqueUsernames(employee, existingUsernames) {
            const firstNameInitial = employee.firstName.charAt(0).toLowerCase();
            const lastNameLower = employee.lastName.replace(/\s+/g, '').toLowerCase(); // Remove spaces from last name
            let baseUsername = firstNameInitial + lastNameLower;
        
            let uniqueUsername = baseUsername;
            let counter = 1;
        
            while (existingUsernames.includes(uniqueUsername)) {
                uniqueUsername = `${baseUsername}${counter}`;
                counter += 1;
            }
        
            existingUsernames.push(uniqueUsername); // Add the new username to the list to avoid duplicates
            return uniqueUsername;
        }
        
        const apiUrl =  domain + "/api/Authentication";

        const existingUsernames = [];
        const dataToAdd = [];

        for(const employee of bulkData){
            const foundEmployee = employeeInfo.find(data => 
                data.employeeId.toLowerCase() === employee.employeeId.toLowerCase()
            );

            accounts.forEach(employee => {
                existingUsernames.push(employee.username);
            });
    
            const username = generateUniqueUsernames(employee, existingUsernames);
            existingUsernames.push(username);
    
            const data = {
                username: username,
                password: "password",
                employeePersonalInformationId: foundEmployee.id,
                accessTemplateId: foundTemplate.id
            };

            dataToAdd.push(data)
        }

        try {
            axios.post(apiUrl + `/register/bulk`, dataToAdd, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            
        } catch (error) {
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        }
    }

    const convertToDateTime = (value) => {
        if (value === null || value === undefined || value === '' || (typeof value === 'string' && value.startsWith('<') && value.endsWith('>'))) {
            return null;
        }

        if(!value){
            return null;
        }

        if (typeof value === 'number') {
            // Convert Excel serial number to JavaScript Date
            const excelStartDate = new Date(1899, 11, 31); // Correct base date
            const jsDate = new Date(excelStartDate.getTime() + value * 86400000); // Convert days to milliseconds
            
            return jsDate.toISOString().split('T')[0];
        }

        if (typeof value === 'string') {
            let formattedValue = value.replace(/-/g, '/'); // Ensure compatibility
            
            const parts = formattedValue.split('/');
            if (parts.length === 3) {
                let [first, second, third] = parts.map(p => parseInt(p, 10));
    
                let year, month, day;
    
                if (third > 31) {
                    // Case: YYYY/MM/DD (Ensure proper year detection)
                    year = third;
                    month = first;
                    day = second;
                } else if (first > 12) {
                    // Case: DD/MM/YYYY (Auto-detect)
                    day = first;
                    month = second;
                    year = third;
                } else {
                    // Case: MM/DD/YYYY (US format)
                    month = first;
                    day = second;
                    year = third;
                }
    
                return new Date(Date.UTC(year, month - 1, day)).toISOString().split('T')[0]; // Return YYYY-MM-DD
            }
        }

        return null
    }

    const [uploadEmployees_temp, setUploadEmployees_temp] = useState([])
    const uploadEmployeeData = async (file) => {
        setLoadingUploadRequest(true);
        const dataLocation = await fetchDataForLocation();
        const dataEmployment = await fetchDataForEmployment();
        const dataDepartment = await fetchDataForDepartment();
        const dataSection = await fetchDataForSection();
        const dataClassification = await fetchDataForClassification();
        const dataPaytype = await fetchDataForPaytype();
        const dataShiftSchedule = await fetchDataForShiftSchedule();
        const dataPosition = await fetchDataForPosition();
        const dataCompany = await fetchDataForCompany();
        const dataSalaryType = fetchSalaryType;
        const dataForJobTitle = await fetchDataForJobTitle();
        const dataForEmployeeGroup1 = await fetchDataForEmployeeGroup1();
        const dataForEmployeeGroup2 = await fetchDataForEmployeeGroup2();
        const dataForPlantilya = await fetchDataForPlantilya();
        const dataForCostCenter = await fetchDataForCostCenter();
        const dataForClient = await fetchDataForClient();
    
        function sanitizeValue(value) {
            if (value === null || value === undefined || value === '' || (typeof value === 'string' && value.startsWith('<') && value.endsWith('>'))) {
                return '';
            }
            return value;
        }
        function sanitizeValueIntType(value) {
            if (value === null || value === undefined || value === '' || (typeof value === 'string' && value.startsWith('<') && value.endsWith('>'))) {
                return 1;
            }
            return value;
        }
        function sanitizeValueToNull(value) {
            if (value === null || value === undefined || value === '' || (typeof value === 'string' && value.startsWith('<') && value.endsWith('>'))) {
                return null;
            }
            return value;
        }
    
        function validateData(data) {
            let newData = [];
        
            data.forEach((item, index) => {
                const missing = [];
                
                if (!item.employeeId) missing.push('Employee Id');
                if (!item.firstName) missing.push('First Name');
                if (!item.lastName) missing.push('Last Name');
                if (!item.employeeInformation) missing.push('Employee Information');
        
                const existingEmployee = employees.find(employee => employee.employeeId === item.employeeId?.toString());
        
                // ✅ Construct error message properly
                let errorMessage = "";
        
                if (missing.length > 0) {
                    errorMessage += ` Missing fields - ${missing.join(', ')}`;
                }
        
                if (existingEmployee) {
                    errorMessage += errorMessage.length > 0 ? ` EmployeeId already exists.` : `EmployeeId already exists. `;
                }
        
                newData.push({ ...item, errors: errorMessage });
            });
            
            newData.sort((a, b) => (a.error ? -1 : 1) - (b.error ? -1 : 1));

            return newData;
        }
    
        const reader = new FileReader();
        reader.onload = async (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: 'array' });
    
            const parseWorksheet = (worksheet) => {
                return XLSX.utils.sheet_to_json(worksheet, { defval: '' });
            };
    
            const employeePersonalInformation = parseWorksheet(workbook.Sheets['EmployeePersonalInformation']);
            const employeeInformation = parseWorksheet(workbook.Sheets['EmployeeInformation']);
            const employeeAccountInformation = parseWorksheet(workbook.Sheets['AccountInformation']);
            const employeeSalary = parseWorksheet(workbook.Sheets['EmployeeSalary']);
            const employeeBankAccount = parseWorksheet(workbook.Sheets['BankAccount']);
            const employeeEducationAttainments = parseWorksheet(workbook.Sheets['EducationalAttainment']);
            const employeeDependents = parseWorksheet(workbook.Sheets['Dependents']);
            const employeeFamilyData = parseWorksheet(workbook.Sheets['FamilyData']);
            const employeeEmergencyContacts = parseWorksheet(workbook.Sheets['EmergencyContact']);
            const employeeLeaves = parseWorksheet(workbook.Sheets['EmployeeLeaves']);
            const employeeStatus = parseWorksheet(workbook.Sheets['EmployeeStatus']);
    
            const bulkData = [];
            const processedIds = new Set();
    
            employeePersonalInformation.forEach(personalInfo => {
                if(!personalInfo.EmployeeId) {
                    return;
                }
                if (processedIds.has(personalInfo.EmployeeId)) {
                    return; // Skip duplicate EmployeeId
                }
                processedIds.add(personalInfo.EmployeeId);
    
                const filteredEmployeeInformation = employeeInformation.filter(row => {
                  return row.EmployeeId === personalInfo.EmployeeId
                });
                const filteredAccountInformation = employeeAccountInformation.filter(row => row.EmployeeId === personalInfo.EmployeeId);
                const filteredSalary = employeeSalary.filter(row => row.EmployeeId === personalInfo.EmployeeId);
                const filteredBankAccount = employeeBankAccount.filter(row => row.EmployeeId === personalInfo.EmployeeId);
                const filteredEducationAttainments = employeeEducationAttainments.filter(row => row.EmployeeId === personalInfo.EmployeeId);
                const filteredDependents = employeeDependents.filter(row => row.EmployeeId === personalInfo.EmployeeId);
                const filteredFamilyData = employeeFamilyData.filter(row => row.EmployeeId === personalInfo.EmployeeId);
                const filteredEmergencyContacts = employeeEmergencyContacts.filter(row => row.EmployeeId === personalInfo.EmployeeId);
                const filteredEmployeeLeaves = employeeLeaves.filter(row => row.EmployeeId === personalInfo.EmployeeId);
                const filteredEmployeeStatus = employeeStatus.filter(row => row.EmployeeId === personalInfo.EmployeeId);
    
                let foundLocation = null;
                let foundEmployment = null;
                let foundDepartment = null;
                let foundSection = null;
                let foundClassification = null;
                let foundPaytype = null;
                let foundShiftSchedule = null;
                let foundPosition = null;
                let foundCompany = null;
                let foundSalaryType = null;
                let foundJobTitle = null;
                let foundEmployeeGroup1 = null;
                let foundEmployeeGroup2 = null;
                let foundPlantilya = null;
                let foundCostCenter = null;
                let foundClient = null;

                if (filteredEmployeeInformation.length > 0) {
                    const employeeInfo = filteredEmployeeInformation[0];

                    foundLocation = dataLocation.find(data => 
                        data.description?.toLowerCase() === sanitizeValue(employeeInfo.Location)?.toString().toLowerCase()
                    );
                    foundEmployment = dataEmployment.find(data => 
                        data.description?.toLowerCase() === sanitizeValue(employeeInfo.Employment)?.toString().toLowerCase()
                    );
                    foundDepartment = dataDepartment.find(data => 
                        data.description?.toLowerCase() === sanitizeValue(employeeInfo.Department)?.toString().toLowerCase()
                    );
                    foundSection = dataSection.find(data => 
                        data.description?.toLowerCase() === sanitizeValue(employeeInfo.Section)?.toString().toLowerCase()
                    );
                    foundClassification = dataClassification.find(data => 
                        data.description?.toLowerCase() === sanitizeValue(employeeInfo.Classification)?.toString().toLowerCase()
                    );
                    foundPaytype = dataPaytype.find(data => 
                        data.description?.toLowerCase() === sanitizeValue(employeeInfo.PayType)?.toString().toLowerCase()
                    );
                    foundShiftSchedule = dataShiftSchedule.find(data => 
                        data.shiftName?.toLowerCase() === sanitizeValue(employeeInfo.ShiftSchedule)?.toString().toLowerCase()
                    );
                    foundPosition = dataPosition.find(data => 
                        data.description?.toLowerCase() === sanitizeValue(employeeInfo.Position)?.toString().toLowerCase()
                    );
                    foundCompany = dataCompany.find(data => 
                        data.name?.toLowerCase() === sanitizeValue(employeeInfo.Company)?.toString().toLowerCase()
                    );
                    foundSalaryType = dataSalaryType.find(data => {
                        let value = sanitizeValue(employeeInfo.SalaryType)?.toString().toLowerCase();
                          return  data.toLowerCase() === value.toLowerCase()
                        }
                    );
                    foundJobTitle = dataForJobTitle.find(data => 
                        data.description?.toLowerCase() === sanitizeValue(employeeInfo.JobTitle)?.toString().toLowerCase()
                    );
                    foundEmployeeGroup1 = dataForEmployeeGroup1.find(data => 
                        data.description?.toLowerCase() === sanitizeValue(employeeInfo.EmployeeGroup1)?.toString().toLowerCase()
                    );
                    foundEmployeeGroup2 = dataForEmployeeGroup2.find(data => 
                        data.description?.toLowerCase() === sanitizeValue(employeeInfo.EmployeeGroup2)?.toString().toLowerCase()
                    );
                    foundPlantilya = dataForPlantilya.find(data => 
                        data.description?.toLowerCase() === sanitizeValue(employeeInfo.Plantilya)?.toString().toLowerCase()
                    );
                    foundCostCenter = dataForCostCenter.find(data => 
                        data.description?.toLowerCase() === sanitizeValue(employeeInfo.CostCenter)?.toString().toLowerCase()
                    );
                    foundClient = dataForClient.find(data => 
                        data.description?.toLowerCase() === sanitizeValue(employeeInfo.Client)?.toString().toLowerCase()
                    );
                }

                // i will use the locations, employments etc. here below
                bulkData.push({
                    employeeId: sanitizeValue(personalInfo.EmployeeId).toString().trim(),
                    lastName: sanitizeValue(personalInfo.LastName),
                    firstName: sanitizeValue(personalInfo.FirstName),
                    middleName: sanitizeValue(personalInfo.MiddleName),
                    extensionName: sanitizeValue(personalInfo.ExtensionName),
                    fullName: sanitizeValue(personalInfo.LastName) + ", " + sanitizeValue(personalInfo.FirstName),
                    nickName: sanitizeValue(personalInfo.NickName),
                    age: personalInfo.Age ? sanitizeValueToNull(personalInfo.Age.toString()) : null,
                    dateOfBirth: personalInfo.DateOfBirth ? convertToDateTime(personalInfo.DateOfBirth) : null,
                    placeOfBirth: sanitizeValue(personalInfo.PlaceOfBirth),
                    civilStatus: sanitizeValue(personalInfo.CivilStatus),
                    bloodType: sanitizeValue(personalInfo.BloodType),
                    height: sanitizeValue(personalInfo.Height)?.toString(),
                    weight: sanitizeValue(personalInfo.Weight)?.toString(),
                    citizenship: sanitizeValue(personalInfo.Citizenship),
                    religion: sanitizeValue(personalInfo.Religion),
                    gender: sanitizeValue(personalInfo.Gender),
                    mobileNumber: sanitizeValue(personalInfo.MobileNumber.toString()),
                    emailAddress: sanitizeValue(personalInfo.EmailAddress),
                    blkLot: sanitizeValue(personalInfo.BlkLot.toString()),
                    street: sanitizeValue(personalInfo.Street)?.toString(),
                    barangay: sanitizeValue(personalInfo.Barangay)?.toString(),
                    city: sanitizeValue(personalInfo.City),
                    postalCode: sanitizeValue(personalInfo.PostalCode.toString()),
                    yearsOfStay: personalInfo.YearsOfStay ? sanitizeValueToNull(personalInfo.YearsOfStay.toString()) : null,
                    employeeInformation: filteredEmployeeInformation[0] ? {
                        employeeId: sanitizeValue(filteredEmployeeInformation[0].EmployeeId).toString(),
                        location: filteredEmployeeInformation[0].Location ? 
                                foundLocation ?
                                    sanitizeValue(filteredEmployeeInformation[0].Location).toString() 
                                    :
                                    ""
                                : 
                                "",
                        dateEmployed: filteredEmployeeInformation[0].DateEmployed ? convertToDateTime(filteredEmployeeInformation[0].DateEmployed) : null,
                        dateRegular: filteredEmployeeInformation[0].DateRegular ? convertToDateTime(filteredEmployeeInformation[0].DateRegular) : null,
                        dateProbationary: filteredEmployeeInformation[0].DateProbationary ? convertToDateTime(filteredEmployeeInformation[0].DateProbationary) : null,
                        dateResigned: filteredEmployeeInformation[0].DateResigned ? convertToDateTime(filteredEmployeeInformation[0].DateResigned) : null,
                        dateProjectBase: filteredEmployeeInformation[0].DateProjectBase ? convertToDateTime(filteredEmployeeInformation[0].DateProjectBase) : null,
                        dateContractual: filteredEmployeeInformation[0].DateContractual ? convertToDateTime(filteredEmployeeInformation[0].DateContractual) : null,
                        employmentDuration: filteredEmployeeInformation[0].EmploymentDuration ? convertToDateTime(filteredEmployeeInformation[0].EmploymentDuration) : null,
                        employment: filteredEmployeeInformation[0].Employment ? 
                                    foundEmployment ?
                                        sanitizeValue(filteredEmployeeInformation[0].Employment).toString() 
                                        :
                                        ""
                                    : 
                                    "",
                        department: filteredEmployeeInformation[0].Department ? 
                                    foundDepartment ?
                                        sanitizeValue(filteredEmployeeInformation[0].Department).toString() 
                                        :
                                        ""
                                    : 
                                    "",
                        section: filteredEmployeeInformation[0].Section ? 
                                foundSection ?
                                    sanitizeValue(filteredEmployeeInformation[0].Section).toString() 
                                    :
                                    ""
                                : 
                                "",
                        classification: filteredEmployeeInformation[0].Classification ? 
                                foundClassification ?
                                    sanitizeValue(filteredEmployeeInformation[0].Classification).toString() 
                                    :
                                    ""
                                : 
                                "",
                        payType: filteredEmployeeInformation[0].PayType ? 
                                foundPaytype ?
                                    sanitizeValue(filteredEmployeeInformation[0].PayType).toString() 
                                    :
                                    ""
                                : 
                                "",
                        shiftSchedule: filteredEmployeeInformation[0].ShiftSchedule ? 
                                foundShiftSchedule ?
                                    sanitizeValue(filteredEmployeeInformation[0].ShiftSchedule).toString() 
                                    :
                                    ""
                                : 
                                "",
                        position: filteredEmployeeInformation[0].Position ? 
                                foundPosition ?
                                  sanitizeValue(filteredEmployeeInformation[0].Position).toString() 
                                  :
                                  ""
                                : 
                                "",
                        company: filteredEmployeeInformation[0].Company ? 
                            foundCompany ?
                                sanitizeValue(filteredEmployeeInformation[0].Company).toString() 
                                :
                                ""
                            : 
                            "",
                        salaryType: filteredEmployeeInformation[0].SalaryType ? 
                            foundSalaryType ?
                                sanitizeValue(filteredEmployeeInformation[0].SalaryType).toString() 
                                :
                                ""
                            : 
                            "",
                        jobTitle: filteredEmployeeInformation[0].JobTitle ? 
                          foundJobTitle ?
                              sanitizeValue(filteredEmployeeInformation[0].JobTitle).toString() 
                              :
                              ""
                          : 
                          "",
                        employeeGroup1: filteredEmployeeInformation[0].EmployeeGroup1 ? 
                          foundEmployeeGroup1 ?
                              sanitizeValue(filteredEmployeeInformation[0].EmployeeGroup1).toString() 
                              :
                              ""
                          : 
                          "",
                        employeeGroup2: filteredEmployeeInformation[0].EmployeeGroup2 ? 
                          foundEmployeeGroup2 ?
                              sanitizeValue(filteredEmployeeInformation[0].EmployeeGroup2).toString() 
                              :
                              ""
                          : 
                          "",
                        plantilya: filteredEmployeeInformation[0].Plantilya ? 
                          foundPlantilya ?
                              sanitizeValue(filteredEmployeeInformation[0].Plantilya).toString() 
                              :
                              ""
                          : 
                          "",
                        costCenter: filteredEmployeeInformation[0].CostCenter ? 
                          foundCostCenter ?
                              sanitizeValue(filteredEmployeeInformation[0].CostCenter).toString() 
                              :
                              ""
                          : 
                          "",
                        client: filteredEmployeeInformation[0].Client ? 
                          foundClient ?
                              sanitizeValue(filteredEmployeeInformation[0].Client).toString() 
                              :
                              ""
                          : 
                          "",
                        createdDate: new Date(),
                        createdBy: 0,
                    } : null,
                    employeeAccountInformation: filteredAccountInformation[0] ? {
                        employeeId: sanitizeValue(filteredAccountInformation[0].EmployeeId).toString(),
                        sss: sanitizeValue(filteredAccountInformation[0].Sss).toString(),
                        tin: sanitizeValue(filteredAccountInformation[0].Tin).toString(),
                        passport: sanitizeValue(filteredAccountInformation[0].Passport).toString(),
                        philhealth: sanitizeValue(filteredAccountInformation[0].Philhealth).toString(),
                        pagibig: sanitizeValue(filteredAccountInformation[0].Pagibig).toString(),
                    } : null,
                    employeeBankAccount: filteredBankAccount ? filteredBankAccount.map(bank => ({
                        employeeId: sanitizeValue(bank.EmployeeId).toString(),
                        bankAccount: sanitizeValue(bank.BankAccount).toString(),
                        bankName: sanitizeValue(bank.BankName)?.toString(),
                    })) : [],
                    employeeSalary: filteredSalary[0] ? {
                        employeeId: sanitizeValue(filteredSalary[0].EmployeeId).toString(),
                        salary: sanitizeValueIntType(filteredSalary[0].Salary).toString(),
                        allowance: sanitizeValueIntType(filteredSalary[0].Allowance).toString()
                    } : null,
                    employeeEducationAttainments: filteredBankAccount ? filteredEducationAttainments.map(data => ({
                        employeeId: sanitizeValue(data.EmployeeId).toString(),
                        level: sanitizeValue(data.Level),
                        schoolName: sanitizeValue(data.SchoolName),
                        address: sanitizeValue(data.Address),
                        dateFrom: data.DateFrom ? convertToDateTime(data.DateFrom) : null,
                        dateTo: data.DateTo ? convertToDateTime(data.DateTo) : null,
                        course: sanitizeValue(data.Course),
                        honors: sanitizeValue(data.Honors),
                    })) : [],
                    employeeDependents: filteredDependents ? filteredDependents.map(data => ({
                        employeeId: sanitizeValue(data.EmployeeId).toString(),
                        lastName: sanitizeValue(data.LastName),
                        firstName: sanitizeValue(data.FirstName),
                        middleName: sanitizeValue(data.MiddleName),
                        extensionName: sanitizeValue(data.ExtensionName),
                        dateOfBirth: data.DateOfBirth ? convertToDateTime(data.DateOfBirth) : null,
                        gender: sanitizeValue(data.Gender),
                        civilStatus: sanitizeValue(data.CivilStatus),
                    })) : [],
                    employeeFamilyData: filteredFamilyData ? filteredFamilyData.map(data => ({
                        employeeId: sanitizeValue(data.EmployeeId).toString(),
                        name: sanitizeValue(data.Name),
                        dateOfBirth: data.DateOfBirth ? convertToDateTime(data.DateOfBirth) : null,
                        occupation: sanitizeValue(data.Occupation),
                        contactNumber: sanitizeValue(data.ContactNumber).toString(),
                        age: sanitizeValueIntType(data.Age),
                        address: sanitizeValue(data.Address),
                        relationship: sanitizeValue(data.Relationship),
                    })) : [],
                    employeeEmergencyContacts: filteredEmergencyContacts ? filteredEmergencyContacts.map(data => ({
                        employeeId: sanitizeValue(data.EmployeeId).toString(),
                        name: sanitizeValue(data.Name),
                        relationship: sanitizeValue(data.relationship),
                        contactNumber: sanitizeValue(data.ContactNumber).toString(),
                        address: sanitizeValue(data.Address),
                    })) : [],
                    employeeLeave: filteredEmployeeLeaves[0] ? {
                        employeeId: sanitizeValue(data.EmployeeId).toString(),
                        totalVacation: sanitizeValueIntType(data.VacationLeave),
                        totalSick: sanitizeValueIntType(data.SickLeave),
                        totalServiceIncentive: sanitizeValueIntType(data.ServiceIncentiveLeave),
                        totalSoloParent: sanitizeValueIntType(data.SoloParentLeave),
                        vacationRemaining: sanitizeValueIntType(data.VacationLeaveRemaining),
                        sickRemaining: sanitizeValueIntType(data.SickLeaveRemaining),
                        serviceIncentiveRemaining: sanitizeValueIntType(data.ServiceIncentiveLeaveRemaining),
                        soloParentRemaining: sanitizeValueIntType(data.SoloParentLeaveRemaining),
                    } : null,
                    employeeStatuses: filteredEmployeeStatus[0] ? {
                        employeeId: sanitizeValue(data.EmployeeId).toString(),
                        status: data.EmployeeStatus ? sanitizeValue(data.EmployeeStatus) : "Active",
                    } : null,
                });
            });

            const validatedData = validateData(bulkData);
            const sortedData = validatedData.sort((a, b) => {
                const hasErrorA = a.errors && a.errors.length > 0;
                const hasErrorB = b.errors && b.errors.length > 0;
            
                return hasErrorB - hasErrorA; // Move items with errors to the top
            });
            setUploadEmployees_temp(sortedData)
    
            /* const apiUrl = `${domain}/api/Employee/upload-bulk-temp`;
            // console.log('Final bulkData:', JSON.stringify(bulkData, null, 2));
    
            try {
                const response = await axios.post(apiUrl, bulkData, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                });
                
                setUploadEmployees_temp(response.data)
            } catch (error) {
                console.error('Error:', error);
            } finally {
                setLoadingUploadRequest(false);
            } */
        };
        
        setLoadingUploadRequest(false);
    
        reader.readAsArrayBuffer(file);
    };
    const [uploadEmployeeInformations_temp, setUploadEmployeeInformations_temp] = useState([])
    const uploadForUpdateBulkEmployeeData = async (file) => {
        setLoadingUploadRequest(true);
        const dataLocation = await fetchDataForLocation();
        const dataEmployment = await fetchDataForEmployment();
        const dataDepartment = await fetchDataForDepartment();
        const dataSection = await fetchDataForSection();
        const dataClassification = await fetchDataForClassification();
        const dataPosition = await fetchDataForPosition();
        const dataSalaryType = fetchSalaryType;
        const dataPaytype = await fetchDataForPaytype();
        const dataShiftSchedule = await fetchDataForShiftSchedule();
        const dataCompany = await fetchDataForCompany();
        const dataForJobTitle = await fetchDataForJobTitle();
        const dataForEmployeeGroup1 = await fetchDataForEmployeeGroup1();
        const dataForEmployeeGroup2 = await fetchDataForEmployeeGroup2();
        const dataForPlantilya = await fetchDataForPlantilya();
        const dataForCostCenter = await fetchDataForCostCenter();
        const dataForClient = await fetchDataForClient();
    
        function sanitizeValue(value) {
            if (value === null || value === undefined || value === '' || (typeof value === 'string' && value.startsWith('<') && value.endsWith('>'))) {
                return '';
            }
            return value;
        }

        function validateData(data) {
            let newData = [];
        
            data.forEach((item, index) => {
                const missing = [];
                
                if (!item.employeeId) missing.push('Employee Id');
        
                // ✅ Construct error message properly
                let errorMessage = "";

                const existingEmployee = employees.find(employee => employee.employeeId === item.employeeId?.toString());
                if (!existingEmployee) {
                    errorMessage += errorMessage.length > 0 ? ` Employee Id does not exist.` : `Employee Id does not exist. `;
                }
        
                if (missing.length > 0) {
                    errorMessage += ` Missing fields - ${missing.join(', ')}`;
                }
        
                newData.push({ ...item, errors: errorMessage });
            });
            
            newData.sort((a, b) => (a.error ? -1 : 1) - (b.error ? -1 : 1));

            return newData;
        }

        const reader = new FileReader();
        reader.onload = async (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: 'array' });
    
            const parseWorksheet = (worksheet) => {
                return XLSX.utils.sheet_to_json(worksheet, { defval: '' });
            };
    
            const employeeInformation = parseWorksheet(workbook.Sheets[workbook.SheetNames[0]]);

            const bulkData = [];

            employeeInformation.forEach(personalInfo => {
                let foundLocation = null;
                let foundEmployment = null;
                let foundDepartment = null;
                let foundSection = null;
                let foundClassification = null;
                let foundPosition = null;
                let foundSalaryType = null;
                let foundPaytype = null;
                let foundShiftSchedule = null;
                let foundCompany = null;
                let foundJobTitle = null;
                let foundEmployeeGroup1 = null;
                let foundEmployeeGroup2 = null;
                let foundPlantilya = null;
                let foundCostCenter = null;
                let foundClient = null;

                if (personalInfo) {
                    const employeeInfo = personalInfo;

                    foundLocation = dataLocation.find(data => 
                        data.description?.toLowerCase() === sanitizeValue(employeeInfo.Location)?.toString().toLowerCase()
                    );
                    foundEmployment = dataEmployment.find(data => 
                        data.description?.toLowerCase() === sanitizeValue(employeeInfo.Employment)?.toString().toLowerCase()
                    );
                    foundDepartment = dataDepartment.find(data => 
                        data.description?.toLowerCase() === sanitizeValue(employeeInfo.Department)?.toString().toLowerCase()
                    );
                    foundSection = dataSection.find(data => 
                        data.description?.toLowerCase() === sanitizeValue(employeeInfo.Section)?.toString().toLowerCase()
                    );
                    foundClassification = dataClassification.find(data => 
                        data.description?.toLowerCase() === sanitizeValue(employeeInfo.Classification)?.toString().toLowerCase()
                    );
                    foundPosition = dataPosition.find(data => 
                        data.description?.toLowerCase() === sanitizeValue(employeeInfo.Position)?.toString().toLowerCase()
                    );
                    foundCompany = dataCompany.find(data => 
                        data.name?.toLowerCase() === sanitizeValue(employeeInfo.Company)?.toString().toLowerCase()
                    );
                    foundPaytype = dataPaytype.find(data => {
                        return data.description?.toLowerCase() === sanitizeValue(employeeInfo.PayType)?.toString().toLowerCase()
                    }
                    );
                    foundShiftSchedule = dataShiftSchedule.find(data => 
                        data.shiftName?.toLowerCase() === sanitizeValue(employeeInfo.ShiftSchedule)?.toString().toLowerCase()
                    );
                    foundSalaryType = dataSalaryType.find(data => {
                        let value = sanitizeValue(employeeInfo.SalaryType)?.toString().toLowerCase();
                          return  data.toLowerCase() === value.toLowerCase()
                        }
                    );
                    foundJobTitle = dataForJobTitle.find(data => 
                        data.description?.toLowerCase() === sanitizeValue(employeeInfo.JobTitle)?.toString().toLowerCase()
                    );
                    foundEmployeeGroup1 = dataForEmployeeGroup1.find(data => 
                        data.description?.toLowerCase() === sanitizeValue(employeeInfo.EmployeeGroup1)?.toString().toLowerCase()
                    );
                    foundEmployeeGroup2 = dataForEmployeeGroup2.find(data => 
                        data.description?.toLowerCase() === sanitizeValue(employeeInfo.EmployeeGroup2)?.toString().toLowerCase()
                    );
                    foundPlantilya = dataForPlantilya.find(data => 
                        data.description?.toLowerCase() === sanitizeValue(employeeInfo.Plantilya)?.toString().toLowerCase()
                    );
                    foundCostCenter = dataForCostCenter.find(data => 
                        data.description?.toLowerCase() === sanitizeValue(employeeInfo.CostCenter)?.toString().toLowerCase()
                    );
                    foundClient = dataForClient.find(data => 
                        data.description?.toLowerCase() === sanitizeValue(employeeInfo.Client)?.toString().toLowerCase()
                    );
                }

                bulkData.push({
                    employeeId: personalInfo.EmployeeId.toString(),
                    fullName: personalInfo.EmployeeName.toString(),
                    locationId: foundLocation ? foundLocation.id : null,
                    location: personalInfo.Location,
                    employmentId: foundEmployment ? foundEmployment.id : null,
                    employment: personalInfo.Employment,
                    departmentId: foundDepartment ? foundDepartment.id : null,
                    department: personalInfo.Department,
                    sectionId: foundSection ? foundSection.id : null,
                    section: personalInfo.Section,
                    classificationId: foundClassification ? foundClassification.id : null,
                    classification: personalInfo.Classification,
                    payTypeId: foundPaytype ? foundPaytype.id : null,
                    payType: personalInfo.PayType,
                    shiftScheduleId: foundShiftSchedule ? foundShiftSchedule.id : null,
                    shiftSchedule: personalInfo.ShiftSchedule,
                    positionId: foundPosition ? foundPosition.id : null,
                    position: personalInfo.Position,
                    salaryType: foundSalaryType ? foundSalaryType : null,
                    companyId: foundCompany ? foundCompany.id : null,
                    company: personalInfo.Company,
                    jobTitleId: foundJobTitle ? foundJobTitle.id : null,
                    jobTitle: personalInfo.JobTitle,
                    employeeGroup1Id: foundEmployeeGroup1 ? foundEmployeeGroup1.id : null,
                    employeeGroup1: personalInfo.EmployeeGroup1,
                    employeeGroup2Id: foundEmployeeGroup2 ? foundEmployeeGroup2.id : null,
                    employeeGroup2: personalInfo.EmployeeGroup2,
                    plantilyaId: foundPlantilya ? foundPlantilya.id : null,
                    plantilya: personalInfo.Plantilya,
                    costCenterId: foundCostCenter ? foundCostCenter.id : null,
                    costCenter: personalInfo.CostCenter,
                    clientId: foundClient ? foundClient.id : null,
                    client: personalInfo.Client,
                });
            });

            const validatedData = validateData(bulkData)
            
            const sortedData = validatedData.sort((a, b) => {
                const hasErrorA = a.errors && a.errors.length > 0;
                const hasErrorB = b.errors && b.errors.length > 0;
            
                return hasErrorB - hasErrorA; // Move items with errors to the top
            });

            setUploadEmployeeInformations_temp(sortedData)

            /* const apiUrl = `${domain}/api/Employee/update-information/bulk-temp`;
    
            try {
                const response = await axios.put(apiUrl, bulkData, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                });
                
                setUploadEmployeeInformations_temp(response.data)
            } catch (error) {
                console.error('Error:', error);
            } finally {
                setLoadingUploadRequest(false);
            } */
        };
    
        setLoadingUploadRequest(false);
        reader.readAsArrayBuffer(file);
    };
    const [uploadEmployeeLeaveInformations_temp, setUploadEmployeeLeaveInformations_temp] = useState([])
    const uploadForUpdateLeaveEmployeeData = async (file) => {
        setLoadingUploadRequest(true);

        function sanitizeValue(value) {
            if (value === null || value === undefined || value === '' || (typeof value === 'string' && value.startsWith('<') && value.endsWith('>'))) {
                return 0;
            }
            return value;
        }
        function sanitizeValueString(value) {
            if (value === null || value === undefined || value === '' || (typeof value === 'string' && value.startsWith('<') && value.endsWith('>'))) {
                return "";
            }
            return value;
        }

        function validateData(data) {
            let newData = [];
        
            data.forEach((item, index) => {
                const missing = [];
                
                if (!item.employeeId) missing.push('Employee Id');
        
                // ✅ Construct error message properly
                let errorMessage = "";
                const existingEmployee = employees.find(employee => employee.employeeId === item.employeeId?.toString());
                if (!existingEmployee) {
                    errorMessage += errorMessage.length > 0 ? ` Employee Id does not exist.` : `Employee Id does not exist. `;
                }
        
                if (missing.length > 0) {
                    errorMessage += ` Missing fields - ${missing.join(', ')}`;
                }
        
                newData.push({ ...item, errors: errorMessage });
            });
            
            newData.sort((a, b) => (a.error ? -1 : 1) - (b.error ? -1 : 1));

            return newData;
        }
    
        const reader = new FileReader();
        reader.onload = async (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: 'array' });
    
            const parseWorksheet = (worksheet) => {
                return XLSX.utils.sheet_to_json(worksheet, { defval: '' });
            };
    
            const employeeInformation = parseWorksheet(workbook.Sheets[workbook.SheetNames[0]]);

            const bulkData = [];

            console.log(employeeInformation)

            employeeInformation.forEach(personalInfo => {
                const data = {
                    employeeId: sanitizeValueString(personalInfo?.EmployeeId)?.toString(),
                    fullName: personalInfo?.EmployeeName?.toString(),
                    totalVacation: sanitizeValue(personalInfo.VacationLeave),
                    totalSick: sanitizeValue(personalInfo.SickLeave),
                    totalServiceIncentive: sanitizeValue(personalInfo.ServiceIncentiveLeave),
                    totalSoloParent: sanitizeValue(personalInfo.SoloParentLeave),
                    vacationRemaining: sanitizeValue(personalInfo.VacationLeaveRemaining),
                    sickRemaining: sanitizeValue(personalInfo.SickLeaveRemaining),
                    serviceIncentiveRemaining: sanitizeValue(personalInfo.ServiceIncentiveLeaveRemaining),
                    soloParentRemaining: sanitizeValue(personalInfo.SoloParentLeaveRemaining),
                }

                bulkData.push(data)
            });

            const validatedData = validateData(bulkData)
            
            const sortedData = validatedData.sort((a, b) => {
                const hasErrorA = a.errors && a.errors.length > 0;
                const hasErrorB = b.errors && b.errors.length > 0;
            
                return hasErrorB - hasErrorA; // Move items with errors to the top
            });

            setUploadEmployeeLeaveInformations_temp(sortedData)

            /* const apiUrl = `${domain}/api/Employee/update-leave/bulk-temp`;
    
            try {
                const response = await axios.put(apiUrl, bulkData, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                });
                
                setUploadEmployeeLeaveInformations_temp(response.data)
            } catch (error) {
                console.error('Error:', error);
            } finally {
                setLoadingUploadRequest(false);
            } */
        };
    
        setLoadingUploadRequest(false);
        reader.readAsArrayBuffer(file);
    };

    function handleFileUpload(files) {
        if (!files || files.length === 0) {
            console.error('No files selected');
            return;
        }

        const file = files[0];
        uploadEmployeeData(file);
    }

    const handleFinalFileUpload = async (bulkData) => {
        const apiUrl = `${domain}/api/Employee/upload-bulk`;
        setLoadingRequest(true);
    
        try {
            const response = await axios.post(apiUrl, bulkData, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            
            console.log('Upload successful:', response.data);

            await createAccountBulk(bulkData);

            await SetAuditTrail({
                setupArea: "Employee List", 
                actionTaken: "insert", 
                field: "Upload Employee/s", 
                newValue: "-", 
                oldValue: "-", 
                dateSaved: new Date(), 
                savedById: user.id
            });
            await fetchDataBasicInfo();
            
            setRequestMessage('Upload successful');
            setShowRequestMessage(true);
            setIsSuccess(true);
        } catch (error) {
            setLoadingRequest(false);
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }
    }

    function handleFileUploadForBulkUpdate(files) {
        if (!files || files.length === 0) {
            console.error('No files selected');
            return;
        }

        const file = files[0];
        uploadForUpdateBulkEmployeeData(file);
    }
    const handleFinalFileUploadForBulkUpdate = async (bulkData) => {
        const apiUrl = `${domain}/api/Employee/update-information/bulk`;
        setLoadingRequest(true);
    
        try {
            await axios.put(apiUrl, bulkData, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            await SetAuditTrail({
                setupArea: "Employee List", 
                actionTaken: "upload", 
                field: "Upload For Bulk Update Employee Information", 
                newValue: "-", 
                oldValue: "-", 
                dateSaved: new Date(), 
                savedById: user.id
            });
            await fetchDataBasicInfo();
            
            setRequestMessage('Upload successful');
            setShowRequestMessage(true);
            setIsSuccess(true);
        } catch (error) {
            setLoadingRequest(false);
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }
    }
    function handleFileUploadLeave(files) {
        if (!files || files.length === 0) {
            console.error('No files selected');
            return;
        }

        const file = files[0];
        uploadForUpdateLeaveEmployeeData(file);
    }
    const handleFinalFileUploadLeave = async (bulkData) => {
        setLoadingRequest(true);

        const apiUrl = `${domain}/api/Employee/update-leave/bulk`;
    
        try {
            await axios.put(apiUrl, bulkData, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            await SetAuditTrail({
                setupArea: "Employee List", 
                actionTaken: "upload", 
                field: "Upload Employee's Leave", 
                newValue: "-", 
                oldValue: "-", 
                dateSaved: new Date(), 
                savedById: user.id
            });
            await fetchDataBasicInfo();
            
            setRequestMessage('Upload successful');
            setShowRequestMessage(true);
            setIsSuccess(true);
        } catch (error) {
            setLoadingRequest(false);
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }
    }

    const handleSetting = () =>{
        setShowSetting(!showSetting);
    };

    useEffect(() => {
        var settingIcon = document.getElementById("setting-icon");

        if(showSetting){
            //change the down icon to up
            settingIcon.setAttribute("data-testid", "KeyboardArrowUpIcon"); //Up Arrow Test ID
            settingIcon.children[0].setAttribute("d", `M7.41 15.41 12 10.83l4.59 4.58L18 14l-6-6-6 6z`); // Up Arrow.Path d attribute    
        } else {
            //change the up icon to down
            settingIcon.setAttribute("data-testid", "KeyboardArrowDownIcon"); // Down Arrow Test ID
            settingIcon.children[0].setAttribute("d", `M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6z`); // Down Arrow.Path d attribute
        }

        const handleClickOutside = (event) => {
            if (settingRef.current && !settingRef.current.contains(event.target)) {
                if(buttonRef.current && !buttonRef.current.contains(event.target)){
                    setShowSetting(false);
                }
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };


    }, [showSetting]);
    
    return (
        <div>
            <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
                <div className="LeftSpace"></div>
                <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
                    <div className="EmployeesTabInfo shadow-xl">
                        <div className="employeesTab-header">
                            <div className='sub-title row'>
                                <span style={{padding:"0 5px 0 0", color:"#b0b0b0"}}>{"Personnel >"} </span>
                                <span style={{borderBottom:"1px solid black"}}>{"Employees List"}</span>
                            </div>
                            <div className='row' style={{justifyContent: "space-between", alignItems: "center"}}>
                                <h3>Employees List</h3>
                                <div style={{width:"30%",textAlign:"right"}}>
                                    <button ref={buttonRef} onClick={handleSetting} title="Setting" type="button" className="setting">
                                        <SettingsIcon/>
                                        <KeyboardArrowDownIcon id="setting-icon"/>
                                    </button>
                                    <div ref={settingRef}>
                                        {showSetting && 
                                            <SettingInit
                                            generateDownloadTemplate={generateDownloadTemplate}
                                            generateDownloadMasterlist={generateDownloadMasterlist}
                                            generateDownloadForBulkUpdateTemplate={generateDownloadForBulkUpdateTemplate}
                                            generateDownloadEmployeeInformation={generateDownloadEmployeeInformation}
                                            openUploadFormHandleClick={openUploadFormHandleClick}
                                            openUploadForBulkUpdateEmployeeInformationFormHandleClick={openUploadForBulkUpdateEmployeeInformationFormHandleClick}
                                            openBiometricsListFormHandleClick={openBiometricsListFormHandleClick}
                                            generateDownloadRemainingLeave={generateDownloadRemainingLeave}
                                            generateDownloadLeaveTemplate={generateDownloadLeaveTemplate}
                                            openUploadLeaveFormHandleClick={openUploadLeaveFormHandleClick}
                                            />}
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                        <div className="employeesTab-body">
                            <div className='filters-payroll'>
                                <span>Filter</span>
                                <div className="payroll-item-holder info-item-holder row" style={{padding: "0 10px 20px 10px", justifyContent: "normal"}}>
                                    <div className="filter-item-payroll popUp-item info-item column">
                                        <div className="info-item-label">Filter</div>
                                        <div className="info-item-input">
                                            {Filter(setFilterDataIndex, setActiveRowIds, setSelectedEmployee)}
                                        </div>
                                    </div>
                                    {userAccessData.length <= 0 && 
                                        <div className="filter-item-payroll popUp-item info-item column">
                                            <div className="info-item-label">Classification Type</div>
                                            <div className="info-item-input">
                                                <ClassificationFilterDummy/>
                                            </div>
                                        </div>
                                    }
                                    {userAccessData && (userAccessData.description === "Admin" || userAccessData.description === "HR Head" || userAccessData.description === "HR Assistant") && 
                                        <div className="filter-item-payroll popUp-item info-item column">
                                            <div className="info-item-label">Classification Type</div>
                                            <div className="info-item-input">
                                                <ClassificationFilter1 classificationId={classificationFilterForAdminHRHead} setClassificationId={setClassificationFilterForAdminHRHead} setActiveRowIds={setActiveRowIds} setSelectedEmployee={setSelectedEmployee}/>
                                            </div>
                                        </div>
                                    }
                                    {userAccessData && userAccessData.description === "HR Assistant2" && 
                                        <div className="filter-item-payroll popUp-item info-item column">
                                            <div className="info-item-label">Classification Type</div>
                                            <div className="info-item-input">
                                                <ClassificationFilter2 classificationId={classificationFilterForHRAsst2} setClassificationId={setClassificationFilterForHRAsst2} setActiveRowIds={setActiveRowIds} setSelectedEmployee={setSelectedEmployee}/>
                                            </div>
                                        </div>
                                    }
                                    {userAccessData && userAccessData.description === "HR Assistant3" && 
                                        <div className="filter-item-payroll popUp-item info-item column">
                                            <div className="info-item-label">Classification Type</div>
                                            <div className="info-item-input">
                                                <ClassificationFilter3 classificationId={classificationFilterForHRAsst3} setClassificationId={setClassificationFilterForHRAsst3} setActiveRowIds={setActiveRowIds} setSelectedEmployee={setSelectedEmployee}/>
                                            </div>
                                        </div>
                                    }
                                    { (classificationFilterForAdminHRHead.toString() === "3" || classificationFilterForHRAsst2.toString() === "3") &&
                                        <div className="filter-item-payroll popUp-item info-item column">
                                            <div className="info-item-label">Section</div>
                                            <div className="info-item-input">
                                                <SectionIdSelect sectionId={sectionFilter} setSectionId={setSectionFilter}/>
                                            </div>
                                        </div>
                                    }
                                    { ( ((userAccessData?.description === "Admin" || userAccessData?.description === "HR Head" || userAccessData?.description === "HR Assistant") && (classificationFilterForAdminHRHead.toString() === "2" || classificationFilterForAdminHRHead.toString() === "3" || classificationFilterForAdminHRHead.toString() === "4"))
                                    || ((userAccessData.description === "HR Assistant2") && (classificationFilterForHRAsst2.toString() === "2" || classificationFilterForHRAsst2.toString() === "3" || classificationFilterForHRAsst2.toString() === "4"))
                                    || ((userAccessData.description === "HR Assistant3") && (classificationFilterForHRAsst3.toString() === "2" || classificationFilterForHRAsst3.toString() === "3" || classificationFilterForHRAsst3.toString() === "4"))
                                    || userAccessData?.description === "HR Assistant"
                                    ) &&
                                        <div className="filter-item-payroll popUp-item info-item column">
                                            <div className="info-item-label">Location</div>
                                            <div className="info-item-input">
                                                <LocationIdSelect locationId={locationFilter} setLocationId={setLocationFilter}/>
                                            </div>
                                        </div>
                                    }
                                    <div className="filter-item-payroll popUp-item info-item column" style={{display: "none"}}>
                                        <div className="info-item-label">Sort</div>
                                        <div className="info-item-input">
                                            {Sort(sortFilter, setSortFilter)}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <div className="body-top employee-body-top row">
                                <div className="body-top-search">
                                    {CreateSearchBarWithPlaceHolder("", 
                                                                        "mainte-search row", 
                                                                        "mainte-search-icon", 
                                                                        "mainte-search-input", 
                                                                        (e) => handleFilter(e.target.value), 
                                                                        "Search by " + searchPlaceholder, 
                                                                        SearchIcon)}
                                </div>
                            </div>
                            <div className="body-top-btn row">
                                {CreateButton("", "add row", addHandleClick, "ADD EMPLOYEE", PeopleAltIcon)}
                                {CreateButton("", "approve row", handleUpdate, "APPROVE", DoneIcon)}
                                {CreateButton("", "approve row", ()=>setIsSelectAll(true), "SELECT ALL", ChecklistIcon)}
                                {/* <div style={{display:"none"}}>{CreateButton("", "approve row", ()=>test(), "TEST", ChecklistIcon)}</div> */}
                                {/* {CreateButton("", "download row", generateDownloadTemplate, "DOWNLOAD TEMPLATE", DownloadIcon)}
                                {CreateButton("", "upload row", openUploadFormHandleClick, "UPLOAD EMPLOYEES", FileUploadIcon)}
                                {CreateButton("", "createBio row", openBiometricsListFormHandleClick, "CREATE EMPLOYEES FROM BIOMETRICS", GroupsIcon)} */}
                            </div>
                            <div className='employeesTab-tab'>
                                <div id="container1" className="employeesTab-table container">
                                    <CreateTable
                                        dataList={employees}
                                        dataHeader={header}
                                        dataAccessor={accessor}
                                        editHandleClick={viewEmployeeHandleClick}
                                        setSelectedEmployee={setSelectedEmployee}
                                        employees={employees}
                                        selectedToApprove={selectedToApprove}
                                        setSelectedToApprove={setSelectedToApprove}
                                        activeRowIds={activeRowIds}
                                        setActiveRowIds={setActiveRowIds}
                                        isSelectAll={isSelectAll}
                                        setIsSelectAll={setIsSelectAll}
                                        currentPage={currentPage}
                                        setCurrentPage={setCurrentPage}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <UploadForm  isOpen={showUploadForm} 
                    onClose={closeUploadFormHandleClick}
                    uploadEmployees_temp={uploadEmployees_temp}
                    setUploadEmployees_temp={setUploadEmployees_temp}
                    handleFileUpload={handleFileUpload}
                    handleFinalFileUpload={handleFinalFileUpload}
            >
            </UploadForm>
            <UploadForBulkUpdateForm  isOpen={showUploadForBulkUpdateForm} 
                    onClose={closeUploadForBulkUpdateEmployeeInformationFormHandleClick}
                    uploadEmployeeInformations_temp={uploadEmployeeInformations_temp}
                    setUploadEmployeeInformations_temp={setUploadEmployeeInformations_temp}
                    handleFileUpload={handleFileUploadForBulkUpdate}
                    handleFinalFileUploadForBulkUpdate={handleFinalFileUploadForBulkUpdate}
            >
            </UploadForBulkUpdateForm>
            <UploadLeaveForm  isOpen={showUploadLeaveUpdateForm} 
                    onClose={closeUploadLeaveFormHandleClick}
                    uploadEmployeeLeaveInformations_temp={uploadEmployeeLeaveInformations_temp}
                    setUploadEmployeeLeaveInformations_temp={setUploadEmployeeLeaveInformations_temp}
                    handleFileUpload={handleFileUploadLeave}
                    handleFinalFileUploadLeave={handleFinalFileUploadLeave}
            >
            </UploadLeaveForm>
            {   showBiometricsListForm &&
                <BiometricsList  isOpen={showBiometricsListForm} 
                        onClose={closeBiometricsListFormHandleClick}
                        employees={employees}
                        fetchDataBasicInfo={fetchDataBasicInfo}
                        user={user}
                >
                </BiometricsList>
            }
            { showViewEmployee &&
                <ViewEmployee   user={user}
                                isOpen={showViewEmployee}
                                onClose={closeViewEmployeeHandleClick}
                                viewedData={viewedData}
                                setViewedData={setViewedData}
                                fetchData={fetchDataBasicInfo}
                                employeePhoto={employeePhoto}
                                setEmployeePhoto={setEmployeePhoto}
                />
            }
            <UnapprovedEmployeeModal 
                                isOpen={showUnapprovedEmployees}
                                onClose={closeUnapprovedEmployees}
                                employees={unapprovedEmployees}
            />
            <GenerateMessage form={showRequestMessage}
                    message={isSuccess ? "Request Success!" : requestMessage}
                    isSuccess={isSuccess}
            > 
            </GenerateMessage>
            {/* <GenerateWarningMessage form={showRequestWarningMessage}
                    message={requestWarningMessage}
            > 
            </GenerateWarningMessage> */}
            {loadingRequest || loading ? (
                <div
                    style={{
                    position: "fixed",
                    top: "0",
                    left: "0",
                    width: "100vw",
                    height: "100vh",
                    zIndex: "2000",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                    backgroundColor: "#ffffff59",
                    }}
                >
                    <img src={loadingSpinner} alt="Loading..." />
                </div>
            ) : (
                <></>
                )
            }
            {loadingUploadRequest ? (
                <div
                    style={{
                    position: "fixed",
                    top: "0",
                    left: "0",
                    width: "100vw",
                    height: "100vh",
                    zIndex: "10000",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                    backgroundColor: "#ffffff59",
                    }}
                >
                    <img src={loadingSpinner} alt="Loading..." />
                </div>
            ) : (
                <></>
                )
            }
        </div>
    )
}

function SettingInit({
    generateDownloadTemplate,
    generateDownloadMasterlist,
    generateDownloadForBulkUpdateTemplate,
    generateDownloadEmployeeInformation,
    openUploadForBulkUpdateEmployeeInformationFormHandleClick,
    openUploadFormHandleClick,
    openBiometricsListFormHandleClick,
    generateDownloadRemainingLeave,
    generateDownloadLeaveTemplate,
    openUploadLeaveFormHandleClick,
}){
    return(
        <div id='payroll-setting' className="payroll-setting column">
            <div>
                <div className="flex items-center w-full my-4">
                    <div className="ml-4 flex-grow border-t border-gray-300" style={{borderTop: "1px solid #E0E0E0"}}></div>
                    <span className="mx-4 text-gray-600 font-medium" style={{fontWeight: "bold"}}>Download Informations</span>
                    <div className="mr-4 flex-grow border-t border-gray-300" style={{borderTop: "1px solid #E0E0E0"}}></div>
                </div>
                <div className="payroll-setting-item row" onClick={()=>generateDownloadEmployeeInformation(false)}>
                    <div style={{margin: "10px 5px 0 5px", color:"#29aec5"}}><FileOpenIcon/></div>
                    Download Employee Information
                </div>
                <div className="payroll-setting-item row" onClick={()=>generateDownloadMasterlist(false)}>
                    <div style={{margin: "10px 5px 0 5px", color:"#29aec5"}}><FileOpenIcon/></div>
                    Download Masterlist
                </div>
            </div>

            <div>
                <div className="flex items-center w-full my-4">
                    <div className="ml-4 flex-grow border-t border-gray-300" style={{borderTop: "1px solid #E0E0E0"}}></div>
                    <span className="mx-4 text-gray-600 font-medium" style={{fontWeight: "bold"}}>Register Employee/s</span>
                    <div className="mr-4 flex-grow border-t border-gray-300" style={{borderTop: "1px solid #E0E0E0"}}></div>
                </div>
                <div className="payroll-setting-item row" onClick={()=>generateDownloadTemplate(false)}>
                    <div style={{margin: "10px 5px 0 5px", color:"#1a75ff"}}><DownloadIcon/></div>
                    Download Template
                </div>
                <div className="payroll-setting-item row"onClick={()=>openUploadFormHandleClick()}>
                    <div style={{margin: "10px 5px 0 5px", color:"#47d147"}}><FileUploadIcon/></div>
                    Upload Employee/s
                </div>
                <div className="payroll-setting-item row"onClick={()=>openBiometricsListFormHandleClick()}>
                    <div style={{margin: "10px 5px 0 5px", color:"#ffaa00"}}><GroupsIcon/></div>
                    Create Employee/s From Biometrics
                </div>
            </div>
            
            <div>
                <div className="flex items-center w-full my-4">
                    <div className="ml-4 flex-grow border-t border-gray-300" style={{borderTop: "1px solid #E0E0E0"}}></div>
                    <span className="mx-4 text-gray-600 font-medium" style={{fontWeight: "bold"}}>Update Employee's Information</span>
                    <div className="mr-4 flex-grow border-t border-gray-300" style={{borderTop: "1px solid #E0E0E0"}}></div>
                </div>
                <div className="payroll-setting-item row" onClick={()=>generateDownloadForBulkUpdateTemplate(false)}>
                    <div style={{margin: "10px 5px 0 5px", color:"#1a75ff"}}><DownloadIcon/></div>
                    Download Employee Information Template
                </div>
                <div className="payroll-setting-item row"onClick={()=>openUploadForBulkUpdateEmployeeInformationFormHandleClick()}>
                    <div style={{margin: "10px 5px 0 5px", color:"#47d147"}}><FileUploadIcon/></div>
                    Upload For Bulk Update Employee Information
                </div>
            </div>

            <div>
                <div className="flex items-center w-full my-4">
                    <div className="ml-4 flex-grow border-t border-gray-300" style={{borderTop: "1px solid #E0E0E0"}}></div>
                    <span className="mx-4 text-gray-600 font-medium" style={{fontWeight: "bold"}}>Update Employee's Leaves</span>
                    <div className="mr-4 flex-grow border-t border-gray-300" style={{borderTop: "1px solid #E0E0E0"}}></div>
                </div>
                <div className="payroll-setting-item row" onClick={()=>generateDownloadRemainingLeave(false)}>
                    <div style={{margin: "10px 5px 0 5px", color:"#1a75ff"}}><DownloadIcon/></div>
                    Download Remaining Leave
                </div>
                <div className="payroll-setting-item row" onClick={()=>generateDownloadLeaveTemplate(false)}>
                    <div style={{margin: "10px 5px 0 5px", color:"#1a75ff"}}><DownloadIcon/></div>
                    Download Employee Leave Template
                </div>
                <div className="payroll-setting-item row"onClick={()=>openUploadLeaveFormHandleClick()}>
                    <div style={{margin: "10px 5px 0 5px", color:"#47d147"}}><FileUploadIcon/></div>
                    Upload Employee/s Leave
                </div>
            </div>
        </div>
    )
}
function UploadForm({isOpen, 
    onClose,
    uploadEmployees_temp,
    setUploadEmployees_temp,
    handleFileUpload,
    handleFinalFileUpload}
){
    const handleClose = () => {
        onClose();
        setFiles("");
        setUploadEmployees_temp([]);
    };

    const [files, setFiles] = useState([]);
    const [currentFiles, setCurrentFiles] = useState([]);
    const [hasNoError, setHasNoError] = useState(false);

    useEffect(() => {
        if(uploadEmployees_temp.length > 0){
            const _errorData = uploadEmployees_temp.filter(i => i.errors.length > 0)

            if(_errorData.length <= 0){
                setHasNoError(true)
            } else {
                setHasNoError(false)
            }
        }
    }, [uploadEmployees_temp])

    const handleBrowse = (e) => {
        const fileList = Array.from(e.target.files);
        setFiles(fileList);
    };
    const handleDrop = (e) => {
        e.preventDefault();
        const fileList = Array.from(e.dataTransfer.files);
        setFiles(fileList);
        e.currentTarget.style.backgroundColor = "white";
    };
    const handleDragOver = (e) => {
        e.preventDefault();
        e.currentTarget.style.backgroundColor = "#bdbdbd7d";
    };
    const handleDragOut = (e) => {
        e.preventDefault();
        e.currentTarget.style.backgroundColor = "white";
    };
    const clearFiles = () => {
        // Clear the files state
        setFiles([]);
        // Reset the value of the file input
        document.getElementById('fileInput').value = '';
        setUploadEmployees_temp([]);
    };

    useEffect(() => {
        if(currentFiles !== files){
            setCurrentFiles(files)
            handleFileUpload(files);
        }
    }, [files, handleFileUpload, currentFiles])

    const submit = (e) =>{
        handleFinalFileUpload(uploadEmployees_temp);
        handleClose();
    };

    const [currentPage, setCurrentPage] = useState(1);
    var header = [
        "Employee Id",
        "Full Name",
        "Error",
    ]
    var accessor = [
        "employeeId",
        "fullName",
        "errors",
    ]

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>{"Upload Employee/s"}</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>

                    <div className="popUp-body user-template-body" style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                        
                    </div>

                    <div>
                        <label htmlFor="fileInput" className='browse'>Browse...</label>
                        <input
                            type="file"
                            id="fileInput"
                            onChange={(e)=> handleBrowse(e)}
                            style={{ display: 'none' }}
                        />
                        <div
                            id='drop-files-here'
                            onDrop={(e)=>handleDrop(e)}
                            onDragOver={(e)=>handleDragOver(e)}
                            onDragLeave={(e)=>handleDragOut(e)}
                            style={{
                            border: '2px dashed #ccc',
                            borderRadius: '5px',
                            padding: '20px',
                            marginTop: '10px',
                            textAlign: 'center',
                            }}
                        >
                            Drop files here
                        </div>
                        {files.length > 0 && (
                            <div style={{border:"1px solid #97979745", padding:"10px"}}>
                                <span>Uploaded File:</span>
                                <ul>
                                    {files.map((file, index) => (
                                    <span key={index}>{file.name}</span>
                                    ))}
                                </ul>
                                <div className="buttons row" style={{display:"flex", justifyContent:"end"}}>
                                    <button id="add-family" 
                                    className="cancel row"
                                    onClick={()=>clearFiles()}
                                    style={{marginRight:"5px", height: "34px", borderRadius: "3px"}}>
                                        CLEAR
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                    {files.length > 0 && (
                        <>
                            {hasNoError ?
                            <>
                                <div style={{marginTop: "10px", padding: "10px", backgroundColor: "#4cc92a", color: "white"}}>
                                    Data is valid.
                                </div>
                            </>
                            :
                            <>
                                <div style={{marginTop: "10px", padding: "10px", backgroundColor: "#ce3434", color: "white"}}>
                                    Cannot upload with error.
                                </div>
                            </>
                            }
                            <div className='employeesTab-tab upload-preview-tab' style={{marginTop: "10px"}}>
                                <div id="container1 table-uploads" className="employeesTab-table container">
                                    <CreateTableForUpload
                                        dataList={uploadEmployees_temp}
                                        dataHeader={header}
                                        dataAccessor={accessor}
                                        currentPage={currentPage}
                                        setCurrentPage={setCurrentPage}
                                    />
                                </div>
                            </div>
                            <div className="buttons row" style={{justifyContent:"end", padding:"40px 40px 20px 40px"}}>
                                {hasNoError && <button id="add-family" 
                                    className="save row"
                                    onClick={(e)=>submit(e)}
                                    style={{marginRight:"5px"}}>
                                        UPLOAD
                                </button>}
                                <button id="add-family" 
                                    className="cancel row"
                                    style={{marginRight:"5px", height: "34px", borderRadius: "3px"}}
                                    onClick={()=>handleClose()}>
                                        CANCEL
                                </button>
                            </div>
                        </>
                        )
                    }
                    
                    
                </div>
            )}
            </div>
        </>
    );
}
function UploadForBulkUpdateForm({isOpen, 
    onClose,
    uploadEmployeeInformations_temp,
    setUploadEmployeeInformations_temp,
    handleFileUpload,
    handleFinalFileUploadForBulkUpdate}
){
    const handleClose = () => {
        onClose();
        setFiles("");
        setUploadEmployeeInformations_temp([]);
    };

    const [files, setFiles] = useState([]);
    const [currentFiles, setCurrentFiles] = useState([]);
    const [hasNoError, setHasNoError] = useState(false);

    useEffect(() => {
        if(uploadEmployeeInformations_temp.length > 0){
            const _errorData = uploadEmployeeInformations_temp.filter(i => i.errors.length > 0)

            if(_errorData.length <= 0){
                setHasNoError(true)
            } else {
                setHasNoError(false)
            }
        }
    }, [uploadEmployeeInformations_temp])

    const handleBrowse = (e) => {
        const fileList = Array.from(e.target.files);
        setFiles(fileList);
    };
    const handleDrop = (e) => {
        e.preventDefault();
        const fileList = Array.from(e.dataTransfer.files);
        setFiles(fileList);
        e.currentTarget.style.backgroundColor = "white";
    };
    const handleDragOver = (e) => {
        e.preventDefault();
        e.currentTarget.style.backgroundColor = "#bdbdbd7d";
    };
    const handleDragOut = (e) => {
        e.preventDefault();
        e.currentTarget.style.backgroundColor = "white";
    };
    const clearFiles = () => {
        // Clear the files state
        setFiles([]);
        // Reset the value of the file input
        document.getElementById('fileInput').value = '';
        setUploadEmployeeInformations_temp([]);
    };

    useEffect(() => {
        if(currentFiles !== files){
            setCurrentFiles(files)
            handleFileUpload(files);
        }
    }, [files, handleFileUpload, currentFiles])

    const submit = (e) =>{
        handleFinalFileUploadForBulkUpdate(uploadEmployeeInformations_temp);
        handleClose();
    };

    const [currentPage, setCurrentPage] = useState(1);
    var header = [
        "Employee Id",
        "Employee Name",
        "Location",
        "Employment",
        "Department",
        "Section",
        "Classification",
        "Pay Type",
        "Shift Schedule",
        "Position",
        "Salary Type",
        "Company",
        "Job Title",
        "Employee Group 1",
        "Employee Group 2",
        "Plantilya",
        "CostCenter",
        "Client",
        "Error",
    ]
    var accessor = [
        "employeeId",
        "fullName",
        "location",
        "employment",
        "department",
        "section",
        "classification",
        "payType",
        "shiftSchedule",
        "position",
        "salaryType",
        "company",
        "jobTitle",
        "employeeGroup1",
        "employeeGroup2",
        "plantilya",
        "costCenter",
        "client",
        "errors",
    ]

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>{"Update Employee's Information"}</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>

                    <div className="popUp-body user-template-body" style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                        
                    </div>

                    <div>
                        <label htmlFor="fileInput" className='browse'>Browse...</label>
                        <input
                            type="file"
                            id="fileInput"
                            onChange={(e)=> handleBrowse(e)}
                            style={{ display: 'none' }}
                        />
                        <div
                            id='drop-files-here'
                            onDrop={(e)=>handleDrop(e)}
                            onDragOver={(e)=>handleDragOver(e)}
                            onDragLeave={(e)=>handleDragOut(e)}
                            style={{
                            border: '2px dashed #ccc',
                            borderRadius: '5px',
                            padding: '20px',
                            marginTop: '10px',
                            textAlign: 'center',
                            }}
                        >
                            Drop files here
                        </div>
                        {files.length > 0 && (
                            <div style={{border:"1px solid #97979745", padding:"10px"}}>
                                <span>Uploaded File:</span>
                                <ul>
                                    {files.map((file, index) => (
                                    <span key={index}>{file.name}</span>
                                    ))}
                                </ul>
                                <div className="buttons row" style={{display:"flex", justifyContent:"end"}}>
                                    <button id="add-family" 
                                    className="cancel row"
                                    onClick={()=>clearFiles()}
                                    style={{marginRight:"5px", height: "34px", borderRadius: "3px"}}>
                                        CLEAR
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                    {files.length > 0 && (
                        <>
                            {hasNoError ?
                            <>
                                <div style={{marginTop: "10px", padding: "10px", backgroundColor: "#4cc92a", color: "white"}}>
                                    Data is valid.
                                </div>
                            </>
                            :
                            <>
                                <div style={{marginTop: "10px", padding: "10px", backgroundColor: "#ce3434", color: "white"}}>
                                    Cannot upload with error.
                                </div>
                            </>
                            }
                            <div className='employeesTab-tab upload-preview-tab' style={{marginTop: "10px"}}>
                                <div id="container1 table-uploads" className="employeesTab-table container">
                                    <CreateTableForUpload
                                        dataList={uploadEmployeeInformations_temp}
                                        dataHeader={header}
                                        dataAccessor={accessor}
                                        currentPage={currentPage}
                                        setCurrentPage={setCurrentPage}
                                    />
                                </div>
                            </div>
                            <div className="buttons row" style={{justifyContent:"end", padding:"40px 40px 20px 40px"}}>
                                {hasNoError && <button id="add-family" 
                                    className="save row"
                                    onClick={(e)=>submit(e)}
                                    style={{marginRight:"5px"}}>
                                        UPLOAD
                                </button>}
                                <button id="add-family" 
                                    className="cancel row"
                                    style={{marginRight:"5px", height: "34px", borderRadius: "3px"}}
                                    onClick={()=>handleClose()}>
                                        CANCEL
                                </button>
                            </div>
                        </>
                        )
                    }
                    
                    
                </div>
            )}
            </div>
        </>
    );
}
function UploadLeaveForm({isOpen, 
    onClose,
    uploadEmployeeLeaveInformations_temp,
    setUploadEmployeeLeaveInformations_temp,
    handleFileUpload,
    handleFinalFileUploadLeave}
){
    const handleClose = () => {
        onClose();
        setFiles("");
        setUploadEmployeeLeaveInformations_temp([]);
    };

    const [files, setFiles] = useState([]);
    const [currentFiles, setCurrentFiles] = useState([]);
    const [hasNoError, setHasNoError] = useState(false);

    useEffect(() => {
        if(uploadEmployeeLeaveInformations_temp.length > 0){
            const _errorData = uploadEmployeeLeaveInformations_temp.filter(i => i.errors.length > 0)

            if(_errorData.length <= 0){
                setHasNoError(true)
            } else {
                setHasNoError(false)
            }
        }
    }, [uploadEmployeeLeaveInformations_temp])

    const handleBrowse = (e) => {
        const fileList = Array.from(e.target.files);
        setFiles(fileList);
    };
    const handleDrop = (e) => {
        e.preventDefault();
        const fileList = Array.from(e.dataTransfer.files);
        setFiles(fileList);
        e.currentTarget.style.backgroundColor = "white";
    };
    const handleDragOver = (e) => {
        e.preventDefault();
        e.currentTarget.style.backgroundColor = "#bdbdbd7d";
    };
    const handleDragOut = (e) => {
        e.preventDefault();
        e.currentTarget.style.backgroundColor = "white";
    };
    const clearFiles = () => {
        // Clear the files state
        setFiles([]);
        // Reset the value of the file input
        document.getElementById('fileInput').value = '';
        setUploadEmployeeLeaveInformations_temp([]);
    };

    useEffect(() => {
        if(currentFiles !== files){
            setCurrentFiles(files)
            handleFileUpload(files);
        }
    }, [files, handleFileUpload, currentFiles])

    const submit = (e) =>{
        handleFinalFileUploadLeave(uploadEmployeeLeaveInformations_temp);
        handleClose();
    };

    const [currentPage, setCurrentPage] = useState(1);
    var header = [
        "Employee Id",
        "Employee Name",
        "Vacation Leave",
        "Sick Leave",
        "Service Incentive Leave",
        "Solo Parent Leave",
        "Vacation Leave Remaining",
        "Sick Leave Remaining",
        "Service Incentive Leave Remaining",
        "Solo Parent Leave Remaining",
        "Error",
    ]
    var accessor = [
        "employeeId",
        "fullName",
        "totalVacation",
        "totalSick",
        "totalServiceIncentive",
        "totalSoloParent",
        "vacationRemaining",
        "sickRemaining",
        "serviceIncentiveRemaining",
        "soloParentRemaining",
        "errors",
    ]

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>{"Update Employee's Leave Information"}</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>

                    <div className="popUp-body user-template-body" style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                        
                    </div>

                    <div>
                        <label htmlFor="fileInput" className='browse'>Browse...</label>
                        <input
                            type="file"
                            id="fileInput"
                            onChange={(e)=> handleBrowse(e)}
                            style={{ display: 'none' }}
                        />
                        <div
                            id='drop-files-here'
                            onDrop={(e)=>handleDrop(e)}
                            onDragOver={(e)=>handleDragOver(e)}
                            onDragLeave={(e)=>handleDragOut(e)}
                            style={{
                            border: '2px dashed #ccc',
                            borderRadius: '5px',
                            padding: '20px',
                            marginTop: '10px',
                            textAlign: 'center',
                            }}
                        >
                            Drop files here
                        </div>
                        {files.length > 0 && (
                            <div style={{border:"1px solid #97979745", padding:"10px"}}>
                                <span>Uploaded File:</span>
                                <ul>
                                    {files.map((file, index) => (
                                    <span key={index}>{file.name}</span>
                                    ))}
                                </ul>
                                <div className="buttons row" style={{display:"flex", justifyContent:"end"}}>
                                    <button id="add-family" 
                                    className="cancel row"
                                    onClick={()=>clearFiles()}
                                    style={{marginRight:"5px", height: "34px", borderRadius: "3px"}}>
                                        CLEAR
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                    {files.length > 0 && (
                        <>
                            {hasNoError ?
                            <>
                                <div style={{marginTop: "10px", padding: "10px", backgroundColor: "#4cc92a", color: "white"}}>
                                    Data is valid.
                                </div>
                            </>
                            :
                            <>
                                <div style={{marginTop: "10px", padding: "10px", backgroundColor: "#ce3434", color: "white"}}>
                                    Cannot upload with error.
                                </div>
                            </>
                            }
                            <div className='employeesTab-tab upload-preview-tab' style={{marginTop: "10px"}}>
                                <div id="container1 table-uploads" className="employeesTab-table container">
                                    <CreateTableForUpload
                                        dataList={uploadEmployeeLeaveInformations_temp}
                                        dataHeader={header}
                                        dataAccessor={accessor}
                                        currentPage={currentPage}
                                        setCurrentPage={setCurrentPage}
                                    />
                                </div>
                            </div>
                            <div className="buttons row" style={{justifyContent:"end", padding:"40px 40px 20px 40px"}}>
                                {hasNoError && <button id="add-family" 
                                    className="save row"
                                    onClick={(e)=>submit(e)}
                                    style={{marginRight:"5px"}}>
                                        UPLOAD
                                </button>}
                                <button id="add-family" 
                                    className="cancel row"
                                    style={{marginRight:"5px", height: "34px", borderRadius: "3px"}}
                                    onClick={()=>handleClose()}>
                                        CANCEL
                                </button>
                            </div>
                        </>
                        )
                    }
                    
                    
                </div>
            )}
            </div>
        </>
    );
}
function BiometricsList({isOpen, 
    onClose,
    employees,
    fetchDataBasicInfo,
    user
}
){
    var header = [
        "Employee Id",
        "Full Name",
        "",
    ]
    var accessor = [
        "employeeId",
        "fullName",
        "manage"
    ]

    const [currentPage, setCurrentPage] = useState(1);
    const [employeesFromBio, setEmployeesFromBio] = useState([]);
    const [selectedToAdd, setSelectedToAdd] = useState([]);
    const [dataToAdd, setDataToAdd] = useState([]);
    const [nonExistingDataFromBio, setNonExistingDataFromBio] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loadingRequest, setLoadingRequest] = useState(false);
    const [addConfirmation, setAddConfirmation] = useState(false);
    const [addConfirmationBulk, setAddConfirmationBulk] = useState(false);
    const [isSelectAll, setIsSelectAll] = useState(false);
    const [isAdd, setIsAdd] = useState(false);
    const [filterData, setFilterData] = useState([]);
    const [filterDataIndex, setFilterDataIndex] = useState(0);
    const [searchPlaceholder, setSearchPlaceholder] = useState("Search by name");
    //Request Messages -start
    const [showRequestMessage, setShowRequestMessage] = useState(false);
    const [requestMessage, setRequestMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState("");
    useEffect(() => {
        if (showRequestMessage) {
            const timeoutId = setTimeout(() => {
                setShowRequestMessage(false);
            }, 5000);

            return () => clearTimeout(timeoutId);
        }
        
    }, [showRequestMessage]);
    function GenerateMessage({form, message, isSuccess}){
        return (
            <>
                <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
                    {form && (
                    <div className="modal toggleMessage" style={{backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5"}}>
                        <div className='column'>
                            {isSuccess ?
                                <div className='request_title row' style={{fontWeight:"bold", color:"green", alignItems:"center"}}>
                                    <CheckCircleIcon/>
                                    <span >{"SUCCESS MESSAGE"}</span>
                                </div>
                                :
                                <div className='request_title row' style={{fontWeight:"bold", color:"#DD5746", alignItems:"center"}}>
                                    <ErrorIcon/>
                                    <span>{"ERROR MESSAGE"}</span>
                                </div>
                            }
                            <span style={{textAlign:"center", padding:"10px 0", color: isSuccess? "green" : "#DD5746"}}>{message}</span>
                        </div>
                    </div>
                )}
                </div>
            </>
        );
    }
    //Request Messages -end

    const fetchDataAccessTemplate =  useCallback(async () => {
        const apiUrl =  domain + "/api/AccessTemplate";

            try {
                setLoading(true);
                const response = await axios.get(apiUrl , {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json' // You can include other headers if needed
                }})
                return response.data;
            } catch (error) {
            console.error('Error fetching data:', error);
            return [];
        }
        }, []);
    const fetchDataEmployeeInfoForMasterlist = useCallback(async () => {
        const apiUrl =  domain + "/api/Employee/masterlist";

        try {
            const response = await axios.get(apiUrl, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
            }})
                return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            return []
        }
    }, []);
    const fetchDataAccounts = useCallback(async () => {
        const apiUrl =  domain + "/api/Authentication";

        try {
            setLoading(true);
            const response = await axios.get(apiUrl , {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json' // You can include other headers if needed
            }})
            return response.data; 
        } catch (error) {
            console.error('Error fetching data:', error);
            return []
        }
    }, []);

    const createAccount = async (employee) => {
        const accessTemplate = await fetchDataAccessTemplate();
        const employeeInfo = await fetchDataEmployeeInfoForMasterlist();
        const accounts = await fetchDataAccounts();

        const foundTemplate = accessTemplate.find(data => 
            data.description.toLowerCase() === ("Employee").toLowerCase()
        );
        const foundEmployee = employeeInfo.find(data => 
            data.employeeId.toLowerCase() === employee.employeeId.toLowerCase()
        );

        function generateUniqueUsernames(employee, existingUsernames) {
            const firstNameInitial = employee.firstName.charAt(0).toLowerCase();
            const lastNameLower = employee.lastName.replace(/\s+/g, '').toLowerCase(); // Remove spaces from last name
            let baseUsername = firstNameInitial + lastNameLower;
        
            let uniqueUsername = baseUsername;
            let counter = 1;
        
            while (existingUsernames.includes(uniqueUsername)) {
                uniqueUsername = `${baseUsername}${counter}`;
                counter += 1;
            }
        
            existingUsernames.push(uniqueUsername); // Add the new username to the list to avoid duplicates
            return uniqueUsername;
        }
        
        const apiUrl =  domain + "/api/Authentication";

        const existingUsernames = [];

        accounts.forEach(employee => {
            existingUsernames.push(employee.username);
        });

        const username = generateUniqueUsernames(employee, existingUsernames);
        existingUsernames.push(username);

        const data = {
            username: username,
            password: "password",
            employeePersonalInformationId: foundEmployee.id,
            accessTemplateId: foundTemplate.id
        };

        try {
            axios.post(apiUrl + `/register`, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            
        } catch (error) {
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        }
    }
    const createAccountBulk = async (bulkData) => {
        const accessTemplate = await fetchDataAccessTemplate();
        const accounts = await fetchDataAccounts();
        const employeeInfo = await fetchDataEmployeeInfoForMasterlist();

        const foundTemplate = accessTemplate.find(data => 
            data.description.toLowerCase() === ("Employee").toLowerCase()
        );

        function generateUniqueUsernames(employee, existingUsernames) {
            const firstNameInitial = employee.firstName.charAt(0).toLowerCase();
            const lastNameLower = employee.lastName.replace(/\s+/g, '').toLowerCase(); // Remove spaces from last name
            let baseUsername = firstNameInitial + lastNameLower;
        
            let uniqueUsername = baseUsername;
            let counter = 1;
        
            while (existingUsernames.includes(uniqueUsername)) {
                uniqueUsername = `${baseUsername}${counter}`;
                counter += 1;
            }
        
            existingUsernames.push(uniqueUsername); // Add the new username to the list to avoid duplicates
            return uniqueUsername;
        }
        
        const apiUrl =  domain + "/api/Authentication";

        const existingUsernames = [];
        const dataToAdd = [];

        for(const employee of bulkData){
            const foundEmployee = employeeInfo.find(data => 
                data.employeeId.toLowerCase() === employee.employeeId.toLowerCase()
            );

            accounts.forEach(employee => {
                existingUsernames.push(employee.username);
            });
    
            const username = generateUniqueUsernames(employee, existingUsernames);
            existingUsernames.push(username);
    
            const data = {
                username: username,
                password: "password",
                employeePersonalInformationId: foundEmployee.id,
                accessTemplateId: foundTemplate.id
            };

            dataToAdd.push(data)
        }

        try {
            axios.post(apiUrl + `/register/bulk`, dataToAdd, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            
        } catch (error) {
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        }
    }
    
    const handleClose = () => {
        onClose();
        setSelectedToAdd([]);
        setIsSelectAll(false);
        setFilterDataIndex(0);
    };

    const closeConfirmationHandleClick = () =>{
        setAddConfirmation(false);
    }
    const closeConfirmationBulkHandleClick = () =>{
        setAddConfirmationBulk(false);
    }

    const fetchData = useCallback(async () => {
        const apiUrl =  domain + "/api/Employee/biometrics-employees";
        setLoading(true);

        try {
            const response = await axios.get(apiUrl, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
            }})

            console.log(response.data)

            const nonExistingData = response.data.filter(responseEmployee => 
                !employees.some(employee => employee.employeeId.trim() === responseEmployee.employeeId.trim())
            );

            setNonExistingDataFromBio(nonExistingData);

            if(filterDataIndex === 2){ // filter existing
                const existingData = response.data.filter(responseEmployee => 
                    employees.some(employee => employee.employeeId.trim() === responseEmployee.employeeId.trim())
                );

                setEmployeesFromBio(existingData);
                setFilterData(existingData);
            } else if(filterDataIndex === 3){ // filter non existing
                setEmployeesFromBio(nonExistingData);
                setFilterData(nonExistingData);
            } else {
                setEmployeesFromBio(response.data);
                setFilterData(response.data);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    }, [employees, filterDataIndex]);

    const handleSubmit = async (event) => {
        event.preventDefault();

        const apiUrl =  domain + "/api/Employee";

        const data = {
            employeeId: dataToAdd.employeeId.trim(),
            lastName: dataToAdd.lastName,
            firstName: dataToAdd.firstName,
            fullName: dataToAdd.fullName,
            middleName: "",
            extensionName: "",
            nickName: "",
            age: null,
            dateOfBirth: null,
            placeOfBirth: "",
            civilStatus: "",
            bloodType: "",
            height: "",
            weight: "",
            citizenship: "",
            religion: "",
            gender: "",
            mobileNumber: "",
            emailAddress: "",
            blkLot: "",
            street: "",
            barangay: "",
            city: "",
            postalCode: "",
            yearsOfStay: null,
            photo: "",
            deviceNumber: "",
            employeeInformation: {
                employeePersonalInformationId: 0,
                locationId: 1,
                dateEmployed: null,
                dateRegular: null,
                dateProbationary: null,
                dateProjectBase: null,
                dateContractual: null,
                employmentDuration: null,
                employmentId: 1,
                departmentId: 1,
                sectionId: 1,
                classificationId: 2,
                payTypeId: 1,
                shiftScheduleId: 1,
                positionId: 1,
                companyId: 1,
                salaryType: "",
                createdDate: new Date(),
                createdBy: 0,
                updatedDate: null,
                updatedBy: 0
            },
            employeeStatuses: {
                // employeePersonalInformationId: employeeId,
                status: "Active",
            },
            /* employeeReportTo: {
                employeePersonalInformationId: 0,
                reportToId: null
            },
            employeeAccountInformation: {
                employeePersonalInformationId: 0,
                sss: "",
                tin: "",
                passport: "",
                philhealth: "",
                pagibig: "",
                primaryBankAccountId: null
            },
            employeeBankAccount: [
                {
                employeePersonalInformationId: 0,
                employeePersonalInformationEmployeeId: "",
                bankAccount: "",
                bankName: ""
                }
            ],
            employeeSalary: {
                employeePersonalInformationId: 0,
                salary: "",
                allowance: ""
            },
            employeeRestDays: [
                {
                employeePersonalInformationId: 0,
                day: ""
                }
            ],
            employeeEducationAttainments: [
                {
                employeePersonalInformationId: 0,
                level: "",
                schoolName: "",
                address: "",
                dateFrom: null,
                dateTo: null,
                course: "",
                honors: ""
                }
            ],
            employeeDependents: [
                {
                employeePersonalInformationId: 0,
                lastName: "",
                firstName: "",
                middleName: "",
                extensionName: "",
                dateOfBirth: null,
                gender: "",
                civilStatus: ""
                }
            ],
            employeeFamilyData: [
                {
                employeePersonalInformationId: 0,
                name: "",
                dateOfBirth: null,
                occupation: "",
                contactNumber: "",
                age: null,
                address: "",
                relationship: ""
                }
            ],
            employeeEmergencyContacts: [
                {
                    employeePersonalInformationId: 0,
                    name: "",
                    relationship: "",
                    contactNumber: "",
                    address: ""
                }
            ] */
        };

        try {
            setLoadingRequest(true);
            await axios.post(apiUrl, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            await SetAuditTrail({
                setupArea: "Employee List", 
                actionTaken: "insert", 
                field: "Create Employee/s From Biometrics", 
                newValue: data.fullName, 
                oldValue: "-", 
                dateSaved: new Date(), 
                savedById: user.id
            });
            
            setAddConfirmation(false);

            await fetchData();
            await createAccount(data);
            await fetchDataBasicInfo();
            
            setShowRequestMessage(true);
            setIsSuccess(true);
            setIsAdd(true);
        } catch (error) {
            setLoadingRequest(false);
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }

        setAddConfirmation(false);
    };
    const handleSubmitBulk = async (event) => {
        event.preventDefault();

        setLoadingRequest(true);
    
        const apiUrl = domain + "/api/Employee/bulk";
    
        // Remove duplicates based on employeeId
        const uniqueSelectedToAdd = Array.from(new Set(selectedToAdd.map(data => data.employeeId)))
            .map(id => {
                return selectedToAdd.find(data => data.employeeId === id);
            });
    
        const bulkData = uniqueSelectedToAdd
        .filter(data => data.employeeId.length <= 20)  // Only include employeeId with 20 characters or fewer
        .map(data => ({
            employeeId: data.employeeId.trim(),
            lastName: data.lastName,
            firstName: data.firstName,
            fullName: data.fullName,
            employeeInformation: {
                employeePersonalInformationId: 0,
                locationId: 1,
                dateEmployed: null,
                dateRegular: null,
                dateProbationary: null,
                dateProjectBase: null,
                dateContractual: null,
                employmentDuration: null,
                employmentId: 1,
                departmentId: 1,
                sectionId: 1,
                classificationId: 2,
                payTypeId: 1,
                shiftScheduleId: 1,
                positionId: 1,
                companyId: 1,
                salaryType: "",
                createdDate: new Date(),
                createdBy: 0,
                updatedDate: null,
                updatedBy: 0
            },
            employeeStatuses: {
                status: "Active",
            },
        }));

        // console.log('Final bulkData:', JSON.stringify(bulkData, null, 2));
    
        try {
            await axios.post(apiUrl, bulkData, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            await SetAuditTrail({
                setupArea: "Employee List", 
                actionTaken: "insert", 
                field: "Create Employee/s From Biometrics", 
                newValue: "[bulk data]", 
                oldValue: "-", 
                dateSaved: new Date(), 
                savedById: user.id
            });
            setAddConfirmationBulk(false);
            
            await fetchData();
            await fetchDataBasicInfo();
            
            await createAccountBulk(bulkData);
            
            setIsSelectAll(false);
            setSelectedToAdd([]);
            setIsAdd(true);
            setShowRequestMessage(true);
            setIsSuccess(true);
        } catch (error) {
            setLoadingRequest(false);
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }
    
        setAddConfirmationBulk(false);
    };
    const handleFilter = (value) => {
        const lowercaseValue = value.toLowerCase();
        setCurrentPage(1);
        var res = [];

        switch (filterDataIndex) {
            case 0:
                res = filterData.filter((f) =>
                f.fullName.toLowerCase().includes(lowercaseValue)
                );
                break;
            case 1:
                res = filterData.filter((f) =>
                f.employeeId.toString().startsWith(lowercaseValue)
                );
                break;
            case 2:
                res = filterData.filter((f) =>
                f.fullName.toLowerCase().includes(lowercaseValue)
                );
                break;
            case 3:
                res = filterData.filter((f) =>
                f.fullName.toLowerCase().includes(lowercaseValue)
                );
                break;
            default:
                res = filterData.filter((f) =>
                f.fullName.toLowerCase().includes(lowercaseValue)
                );
                
                break;
        }

        setEmployeesFromBio(res);
    };

    const selectAllHandler = () =>{
        if(isSelectAll){
            setIsSelectAll(false);
        } else {
            setIsSelectAll(true);
        }
    }

    useEffect(() => {
        fetchData();
        switch (filterDataIndex) {
            case 0:
                setSearchPlaceholder("Search by name")
                break;
            case 1:
                setSearchPlaceholder("Search by id")
                break;
            case 2:
                setSearchPlaceholder("Search by name")
                break;
            case 3:
                setSearchPlaceholder("Search by name")
                break;
            default:
                setSearchPlaceholder("Search by name")
                break;
        }
    }, [fetchData, filterDataIndex]);

    useEffect(() => {
        if(isSelectAll){
            setSelectedToAdd(nonExistingDataFromBio);
        } else {
            setSelectedToAdd([]);
        }
    }, [isSelectAll, nonExistingDataFromBio]);

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>{"Employee's List from Biometrics"}</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="transaction-body">
                        <EmployeeFilter setFilterDataIndex={setFilterDataIndex}/>
                        <div className="transaction-body-top row">
                            {CreateSearchBarWithPlaceHolder("", 
                                                            "transaction-search row", 
                                                            "transaction-search-icon", 
                                                            "transaction-search-input", 
                                                            (e)=>handleFilter(e.target.value), 
                                                            searchPlaceholder,
                                                            SearchIcon)}
                            
                        </div>
                        <div className="transaction-body-top row">
                            <div style={{margin:"0 5px"}}>
                                <button className='select' onClick={selectAllHandler}>
                                    { isSelectAll ? "UNSELECT ALL" : "SELECT ALL"}
                                </button>
                            </div>
                            <div  style={{margin:"0 5px"}}>
                                <button className={`${selectedToAdd.length > 0 ? "add" : "add-disabled"}` } 
                                    disabled={selectedToAdd.length > 0 ? false : true}
                                    onClick={()=>setAddConfirmationBulk(true)}>
                                    ADD ALL SELECTED
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="popUp-body biometrics-modal">
                        <div className="select-employee-table employee-list-table">
                            <CreateTableForEmployeesBiometrics
                                dataList={employeesFromBio}
                                dataHeader={header}
                                dataAccessor={accessor}
                                employees={employees}
                                setDataToAdd={setDataToAdd}
                                setAddConfirmation={setAddConfirmation}
                                selectedToAdd={selectedToAdd}
                                setSelectedToAdd={setSelectedToAdd}
                                isSelectAll={isSelectAll}
                                isAdd={isAdd}
                                setIsAdd={setIsAdd}
                                currentPage={currentPage}
                                setCurrentPage={setCurrentPage}
                            />
                            {employeesFromBio.length > 0 ? (
                                <div></div>
                            )
                            :
                            (
                                <div>
                                {loading ? (
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '10vh' }}>
                                        <img src={loadingSpinner} alt="Loading..." />
                                    </div>
                                ) : (
                                        <div> {/*<p>No records to display</p>*/}</div>
                                    )
                                }
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}
            </div>
            <ConfirmationForm  isOpen={addConfirmation} 
                        onClose={closeConfirmationHandleClick}
                        handleConfirm={handleSubmit}
            >
            </ConfirmationForm>
            <ConfirmationBulkForm  isOpen={addConfirmationBulk} 
                        onClose={closeConfirmationBulkHandleClick}
                        handleConfirm={handleSubmitBulk}
            >
            </ConfirmationBulkForm>
            <GenerateMessage form={showRequestMessage}
                    message={isSuccess ? "Request Success!" : requestMessage}
                    isSuccess={isSuccess}
            > 
            </GenerateMessage>
            {loadingRequest ? (
                <div style={{ position:"fixed", top:"50%", left:"50%", transform:"translate(-50%, -50%)", zIndex:"3005"}}>
                    <img src={loadingSpinner} alt="Loading..." />
                </div>
            ) : (
                <></>
                )
            }
        </>
    );
}
function EmployeeFilter({setFilterDataIndex}){
    const [selectedOption, setSelectedOption] = useState("All");

    const handleSelectChange = (event) => {
        setSelectedOption(event.target.value);

        switch (event.target.value) {
            case "All":
                setFilterDataIndex(0);
                break;
            case "EmployeeId":
                setFilterDataIndex(1);
                break;
            case "ExistingEmployee":
                setFilterDataIndex(2);
                break;
            case "NonExistingEmployee":
                setFilterDataIndex(3);
                break;
            default:
                setFilterDataIndex(0);
                break;
        }
    };

    return (
        <div className="filters row" style={{alignItems:"center"}}>
            <span style={{marginRight:"10px"}}>Filter</span>
            <select id="" className="filterSelect" value={selectedOption} onChange={handleSelectChange}>
                <option value="All">All</option>
                <option value="EmployeeId">Employee Id</option>
                <option value="ExistingEmployee">Existing Employee</option>
                <option value="NonExistingEmployee">Non Existing Employee</option>
            </select>
        </div>
    );
};
function CreateTableForUpload({ dataList = [], 
    dataHeader = [], 
    dataAccessor = [],
    currentPage, setCurrentPage,
}) {
    const itemsPerPage = 7;

    const columns = React.useMemo(() =>
        dataHeader.map((header, index) => ({
            Header: header,
            accessor: dataAccessor[index]
        })),
        [dataHeader, dataAccessor]
    );

    const [sortHeaderValue, setSortHeaderValue] = useState({ id: "", desc: false, isDefault: true });

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
        setSortBy
    } = useTable(
        {
            columns,
            data: dataList,
            initialState: {
                sortBy: sortHeaderValue.isDefault
                    ? []  // No sorting if it's default
                    : [{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }] // Apply sorting if not default
            }
        },
        useSortBy
    );

    const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
    const indexOfLastItem = Math.min(currentPage * itemsPerPage, rows.length);
    const currentItems = rows.slice(indexOfFirstItem, indexOfLastItem);

    const totalPages = Math.ceil(rows.length / itemsPerPage);
    const isLastPage = currentPage === totalPages;

    const paginate = (pageNumber) => {
        if (pageNumber >= 1 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
        }
    };

    //Sorting Feature
    const sortState = [
        { id: 0, state: "default", textValue: "" },
        { id: 1, state: "ascending", textValue: "↑" },
        { id: 2, state: "descending", textValue: "↓" }
    ];

    const headerClick = (column) => {
        if (sortHeaderValue.id !== column.id) {
            // New column selected, start with ascending order
            setSortHeaderValue({ id: column.id, desc: false, isDefault: false });
            setSortBy([{ id: column.id, desc: false }]);
        } else {
            // Toggle between sorting states (default -> ascending -> descending -> default)
            if (sortHeaderValue.isDefault) {
                setSortHeaderValue({ id: column.id, desc: false, isDefault: false }); // Ascending
                setSortBy([{ id: column.id, desc: false }]);
            } else if (!sortHeaderValue.desc) {
                setSortHeaderValue({ id: column.id, desc: true, isDefault: false }); // Descending
                setSortBy([{ id: column.id, desc: true }]);
            } else {
                setSortHeaderValue({ id: "", desc: false, isDefault: true }); // Default (no sorting)
                setSortBy([]); // Clear sorting
            }
        }
    };

    // Ensure sorting is reapplied on dataList reload
    useEffect(() => {
        if (!sortHeaderValue.isDefault && sortHeaderValue.id) {
            setSortBy([{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }]);
        }
    }, [dataList, setSortBy, sortHeaderValue]);

    return (
        <div>
            <table {...getTableProps()} className='border-collapse'>
                <thead>
                    {headerGroups.map((headerGroup) => (
                        <tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => (
                                <th
                                {...column.getHeaderProps()}
                                onClick={() => headerClick(column)}
                                className="sortable-header"
                            >
                                {`${column.render("Header")} ${
                                    sortHeaderValue.id === column.id
                                        ? sortState[sortHeaderValue.isDefault ? 0 : sortHeaderValue.desc ? 2 : 1].textValue
                                        : ""
                                }`}
                            </th>
                            ))}
                        </tr>
                    ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                    {dataList.length <= 0 &&
                        <tr>
                            <td colSpan={columns.length} style={{ textAlign: "center" }}>
                                No data to display
                            </td>
                        </tr>
                    }
                    {currentItems.map((row) => {
                        prepareRow(row)
                        return (
                                <tr key={row.original.id}
                                {...row.getRowProps()}
                                className={row.original.error ? "error" : ""}
                                >
                                    {row.cells.map((cell) => (
                                        <SetInfoForUpload header={cell.render("Cell").props.column.Header}
                                        _cell={cell}
                                        />
                                    ))}
                                </tr>
                        )
                    })}
                </tbody>
            </table>
            {rows.length > itemsPerPage ? (
            <div>
                <div className='table-page row' style={{alignItems:"center", justifyContent:"end", padding: "20px 0 0 0"}}>
                    <button className='prev row' onClick={() => paginate(1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"25px" }}>
                        &lt;&lt;
                    </button>
                    <button className='prev row' onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"25px" }}>
                        <NavigateBeforeIcon style={{marginRight:"5px"}}/> PREVIOUS
                    </button>
                    <button className='next row' onClick={() => paginate(currentPage + 1)} disabled={indexOfLastItem >= rows.length}
                        style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', marginRight:"5px", height:"25px" }}>
                        NEXT <NavigateNextIcon style={{ marginLeft: "5px" }} />
                    </button>
                    <button className='next row' onClick={() => paginate(totalPages)} disabled={indexOfLastItem >= rows.length}
                        style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', height:"25px"}}>
                        &gt;&gt;
                    </button>
                </div>
                {`${currentPage}/${totalPages}`}
            </div>
            ) :
            <></>}
        </div>
    )
}
function SetInfoForUpload({header, 
    _cell, 
}) {
    const data = _cell.render("Cell").props.row.original;
    const value = _cell.render("Cell").props.value;

    if (header === "Photo") {
        if(data.photo){
            const imageSrc = 'data:image/jpeg;base64,' + data.photo;

            return(
                <td>
                    <img className="avatarImg" src={imageSrc} alt=""/>
                </td>
            )
        }
        return(
            <td>
                <img className="avatarImg" src="images/sample.jpg" alt=""/>
            </td>
        )
    }

    if(header === "Date Created"
    ){
        if(!value){
            return (
                <td>
                </td>
            );
        }

        const date = new Date(_cell.render("Cell").props.value);
        if(!date) {
            return (
                <td>
                    null
                </td>
            );
        }

        const mm = date.getMonth() + 1; // Adding 1 because getMonth returns 0-indexed months
        const dd = date.getDate();
        const yyyy = date.getFullYear();

        const formattedDateFrom = `${mm}/${dd}/${yyyy}`;
        
        return(
            <td>
                {formattedDateFrom}
            </td>
        )
    }

    if(header === "Error"
    ){
        return (
            <td>
                {value && (
                    <p style={{ color: "red", margin: 0 }}>
                        {value}
                    </p>
                )}
            </td>
        );
    }

    if( header === "Vacation Leave"
    || header === "Sick Leave"
    || header === "Service Incentive Leave"
    || header === "Solo Parent Leave"
    || header === "Vacation Leave Remaining"
    || header === "Sick Leave Remaining"
    || header === "Service Incentive Leave Remaining"
    || header === "Solo Parent Leave Remaining"
    ){
        const value = _cell.render("Cell").props.value;

        // Check if value is a number
        const isNumber = typeof value === 'number';

        const numberWithCommasAndDecimal = (number) => {
            return number.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        };

        if(!isNumber){
            return (
                <td {..._cell.getCellProps()}> {
                    _cell.render("Cell")
                    }
                </td>
            )
        }

        const formattedNumber = numberWithCommasAndDecimal(value);

        return(
            <td>
                {formattedNumber}
            </td>
        )
    }

    return (
        <td {..._cell.getCellProps()}> {_cell.render("Cell")}</td>
    )
}
function CreateTable({ dataList = [], 
    dataHeader = [], 
    dataAccessor = [], 
    editHandleClick, 
    employees, 
    setSelectedEmployee,
    selectedToApprove,
    setSelectedToApprove, 
    currentPage, setCurrentPage,
    isSelectAll, setIsSelectAll, activeRowIds, setActiveRowIds
}) {
    const itemsPerPage = 7;

    const columns = React.useMemo(() =>
        dataHeader.map((header, index) => ({
            Header: header,
            accessor: dataAccessor[index]
        })),
        [dataHeader, dataAccessor]
    );

    const [sortHeaderValue, setSortHeaderValue] = useState({ id: "", desc: false, isDefault: true });

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
        setSortBy
    } = useTable(
        {
            columns,
            data: dataList,
            initialState: {
                sortBy: sortHeaderValue.isDefault
                    ? []  // No sorting if it's default
                    : [{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }] // Apply sorting if not default
            }
        },
        useSortBy
    );

    const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
    const indexOfLastItem = Math.min(currentPage * itemsPerPage, rows.length);
    const currentItems = rows.slice(indexOfFirstItem, indexOfLastItem);

    const totalPages = Math.ceil(rows.length / itemsPerPage);
    const isLastPage = currentPage === totalPages;

    const paginate = (pageNumber) => {
        if (pageNumber >= 1 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
        }
    };

    useEffect(()=>{
        if(isSelectAll){
            const newActiveRowIds = rows.map(item => item.original.id);
            const newActiveRowOriginal = rows.map(item => item.original);
            setActiveRowIds(newActiveRowIds);
            setSelectedEmployee(newActiveRowOriginal);
            setIsSelectAll(false);
        }
    }, [isSelectAll, setIsSelectAll, setSelectedEmployee, rows, setActiveRowIds])

    const handleRowClick = (rowData) => {
        setSelectedEmployee(prevSelected => {
            const isAlreadySelected = prevSelected.some(item => item.id === rowData.id);
            return isAlreadySelected
                ? prevSelected.filter(item => item.id !== rowData.id)  // Remove rowData if already selected
                : [...prevSelected, rowData];                         // Add rowData if not selected
        });
        setActiveRowIds(prevIds => 
            prevIds.includes(rowData.id) 
            ? prevIds.filter(id => id !== rowData.id)  // Remove the row ID if it is already active
            : [...prevIds, rowData.id]                 // Add the new row ID if it is not already active
        );
    };

    //Sorting Feature
    const sortState = [
        { id: 0, state: "default", textValue: "" },
        { id: 1, state: "ascending", textValue: "↑" },
        { id: 2, state: "descending", textValue: "↓" }
    ];

    const headerClick = (column) => {
        if (sortHeaderValue.id !== column.id) {
            // New column selected, start with ascending order
            setSortHeaderValue({ id: column.id, desc: false, isDefault: false });
            setSortBy([{ id: column.id, desc: false }]);
        } else {
            // Toggle between sorting states (default -> ascending -> descending -> default)
            if (sortHeaderValue.isDefault) {
                setSortHeaderValue({ id: column.id, desc: false, isDefault: false }); // Ascending
                setSortBy([{ id: column.id, desc: false }]);
            } else if (!sortHeaderValue.desc) {
                setSortHeaderValue({ id: column.id, desc: true, isDefault: false }); // Descending
                setSortBy([{ id: column.id, desc: true }]);
            } else {
                setSortHeaderValue({ id: "", desc: false, isDefault: true }); // Default (no sorting)
                setSortBy([]); // Clear sorting
            }
        }
    };

    // Ensure sorting is reapplied on dataList reload
    useEffect(() => {
        if (!sortHeaderValue.isDefault && sortHeaderValue.id) {
            setSortBy([{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }]);
        }
    }, [dataList, setSortBy, sortHeaderValue]);

    return (
        <div>
            <table {...getTableProps()} className='border-collapse'>
                <thead>
                    {headerGroups.map((headerGroup) => (
                        <tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => (
                                <th
                                {...column.getHeaderProps()}
                                onClick={() => headerClick(column)}
                                className="sortable-header"
                            >
                                {`${column.render("Header")} ${
                                    sortHeaderValue.id === column.id
                                        ? sortState[sortHeaderValue.isDefault ? 0 : sortHeaderValue.desc ? 2 : 1].textValue
                                        : ""
                                }`}
                            </th>
                            ))}
                        </tr>
                    ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                    {dataList.length <= 0 &&
                        <tr>
                            <td colSpan={columns.length} style={{ textAlign: "center" }}>
                                No data to display
                            </td>
                        </tr>
                    }
                    {currentItems.map((row) => {
                        prepareRow(row)
                        return (
                            employees?.length > 0 ?
                                <tr key={row.original.id}
                                {...row.getRowProps()}
                                onClick={() => handleRowClick(row.original)} // Attach onClick event handler to the row
                                className={activeRowIds.includes(row.original.id) ? 'active' : ''}
                                >
                                    {row.cells.map((cell) => (
                                        <SetInfo header={cell.render("Cell").props.column.Header}
                                        _cell={cell}
                                        editHandleClick={editHandleClick}
                                        selectedToApprove={selectedToApprove}
                                        setSelectedToApprove={setSelectedToApprove}
                                        />
                                    ))}
                                </tr>
                            :
                                <></>
                        )
                    })}
                </tbody>
            </table>
            {rows?.length > itemsPerPage && employees?.length > 0 ? (
            <div>
                <div className='table-page row' style={{alignItems:"center", justifyContent:"end", padding: "20px 0 0 0"}}>
                    <button className='prev row' onClick={() => paginate(1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"25px" }}>
                        &lt;&lt;
                    </button>
                    <button className='prev row' onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"25px" }}>
                        <NavigateBeforeIcon style={{marginRight:"5px"}}/> PREVIOUS
                    </button>
                    <button className='next row' onClick={() => paginate(currentPage + 1)} disabled={indexOfLastItem >= rows.length}
                        style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', marginRight:"5px", height:"25px" }}>
                        NEXT <NavigateNextIcon style={{ marginLeft: "5px" }} />
                    </button>
                    <button className='next row' onClick={() => paginate(totalPages)} disabled={indexOfLastItem >= rows.length}
                        style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', height:"25px"}}>
                        &gt;&gt;
                    </button>
                </div>
                {`${currentPage}/${totalPages}`}
            </div>
            ) :
            <></>}
        </div>
    )
}
function SetInfo({header, 
    _cell, 
    editHandleClick,
    selectedToApprove,
    setSelectedToApprove
}) {
    const data = _cell.render("Cell").props.row.original;
    const value = _cell.render("Cell").props.value;

    const [isChecked, setIsChecked] = useState(false);

    const handleItem = (event) => {
        const checked = event.target.checked;
        setIsChecked(checked);

        if (checked) {
            setSelectedToApprove(prevItems => [...prevItems, data]);
        } else {
            setSelectedToApprove(prevItems => prevItems.filter(i => i !== data));
        }
    };

    if (header === "Photo") {
        if(data.photo){
            const imageSrc = 'data:image/jpeg;base64,' + data.photo;

            return(
                <td>
                    <img className="avatarImg" src={imageSrc} alt=""/>
                </td>
            )
        }
        return(
            <td>
                <img className="avatarImg" src="images/sample.jpg" alt=""/>
            </td>
        )
    }

    if (header === "Is Approved?") {
        if(value === "Approved"){
            return (
                <td>
                    <input type="checkbox" 
                        id="overtime-allowance" 
                        className="checkbox"
                        name="" 
                        checked={true}
                        disabled
                    />
                </td>
            )
        }

        if(!value){
            return (
                <td>
                    <input type="checkbox" 
                        id="overtime-allowance" 
                        className="checkbox"
                        name="" 
                        checked={isChecked}
                        onChange={handleItem}
                        disabled
                    />
                </td>
            )
        }

        return(
            <td>
                {_cell.render("Cell").props.value}
            </td>
        )
    }

    if (header === "") {
        return(
            <td>
                <div className="row"  style={{alignItems:"center", justifyContent:"center"}}>
                    <TooltipManage text="View">
                    <div style={{padding:"0 5px"}} onClick={()=>editHandleClick(data)}><RemoveRedEyeIcon/></div>
                    </TooltipManage>
                </div>
            </td>
        )
    }

    if(header === "Date Created"
    ){
        if(!value){
            return (
                <td>
                </td>
            );
        }

        const date = new Date(_cell.render("Cell").props.value);
        if(!date) {
            return (
                <td>
                    null
                </td>
            );
        }

        const mm = date.getMonth() + 1; // Adding 1 because getMonth returns 0-indexed months
        const dd = date.getDate();
        const yyyy = date.getFullYear();

        const formattedDateFrom = `${mm}/${dd}/${yyyy}`;
        
        return(
            <td>
                {formattedDateFrom}
            </td>
        )
    }

    return (
        <td {..._cell.getCellProps()}> {_cell.render("Cell")}</td>
    )
}
function CreateTableForEmployeesBiometrics({ dataList = [], 
    dataHeader = [], 
    dataAccessor = [], 
    employees, 
    setDataToAdd, 
    setAddConfirmation, 
    selectedToAdd,
    setSelectedToAdd,
    isSelectAll,
    isAdd,
    setIsAdd,
    
    currentPage, setCurrentPage,
}) {
    const itemsPerPage = 7;

    const columns = React.useMemo(() =>
        dataHeader.map((header, index) => ({
            Header: header,
            accessor: dataAccessor[index]
        })),
        [dataHeader, dataAccessor]
    );

    const [sortHeaderValue, setSortHeaderValue] = useState({ id: "", desc: false, isDefault: true });

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
        setSortBy
    } = useTable(
        {
            columns,
            data: dataList,
            initialState: {
                sortBy: sortHeaderValue.isDefault
                    ? []  // No sorting if it's default
                    : [{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }] // Apply sorting if not default
            }
        },
        useSortBy
    );

    const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
    const indexOfLastItem = Math.min(currentPage * itemsPerPage, rows.length);
    const currentItems = rows.slice(indexOfFirstItem, indexOfLastItem);

    const totalPages = Math.ceil(rows.length / itemsPerPage);
    const isLastPage = currentPage === totalPages;

    const paginate = (pageNumber) => {
        if (pageNumber >= 1 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
        }
    };

    //Sorting Feature
    const sortState = [
        { id: 0, state: "default", textValue: "" },
        { id: 1, state: "ascending", textValue: "↑" },
        { id: 2, state: "descending", textValue: "↓" }
    ];

    const headerClick = (column) => {
        if (sortHeaderValue.id !== column.id) {
            // New column selected, start with ascending order
            setSortHeaderValue({ id: column.id, desc: false, isDefault: false });
            setSortBy([{ id: column.id, desc: false }]);
        } else {
            // Toggle between sorting states (default -> ascending -> descending -> default)
            if (sortHeaderValue.isDefault) {
                setSortHeaderValue({ id: column.id, desc: false, isDefault: false }); // Ascending
                setSortBy([{ id: column.id, desc: false }]);
            } else if (!sortHeaderValue.desc) {
                setSortHeaderValue({ id: column.id, desc: true, isDefault: false }); // Descending
                setSortBy([{ id: column.id, desc: true }]);
            } else {
                setSortHeaderValue({ id: "", desc: false, isDefault: true }); // Default (no sorting)
                setSortBy([]); // Clear sorting
            }
        }
    };

    // Ensure sorting is reapplied on dataList reload
    useEffect(() => {
        if (!sortHeaderValue.isDefault && sortHeaderValue.id) {
            setSortBy([{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }]);
        }
    }, [dataList, setSortBy, sortHeaderValue]);

    return (
        <div>
            <table {...getTableProps()} className='border-collapse'>
                <thead>
                    {headerGroups.map((headerGroup) => (
                        <tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => (
                                <th
                                {...column.getHeaderProps()}
                                onClick={() => headerClick(column)}
                                className="sortable-header"
                            >
                                {`${column.render("Header")} ${
                                    sortHeaderValue.id === column.id
                                        ? sortState[sortHeaderValue.isDefault ? 0 : sortHeaderValue.desc ? 2 : 1].textValue
                                        : ""
                                }`}
                            </th>
                            ))}
                        </tr>
                    ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                    {dataList.length <= 0 &&
                        <tr>
                            <td colSpan={columns.length} style={{ textAlign: "center" }}>
                                No data to display
                            </td>
                        </tr>
                    }
                    {currentItems.map((row) => {
                        prepareRow(row)
                        return (
                            employees.length > 0 ?
                                <tr key={row.original.id}
                                {...row.getRowProps()}
                                >
                                    {row.cells.map((cell) => (
                                        <SetInfoForEmployeesBiometrics 
                                                header={cell.render("Cell").props.column.Header}
                                                _cell={cell}
                                                employees={employees}
                                                setDataToAdd={setDataToAdd}
                                                setAddConfirmation={setAddConfirmation}
                                                selectedToAdd={selectedToAdd}
                                                setSelectedToAdd={setSelectedToAdd}
                                                isSelectAll={isSelectAll}
                                                isAdd={isAdd}
                                                setIsAdd={setIsAdd}
                                        />
                                    ))}
                                </tr>
                            :
                                <></>
                        )
                    })}
                </tbody>
            </table>
            {rows.length > itemsPerPage && employees.length > 0 ? (
            <div>
                <div className='table-page row' style={{alignItems:"center", justifyContent:"end", padding: "20px 0 0 0"}}>
                    <button className='prev row' onClick={() => paginate(1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"25px" }}>
                        &lt;&lt;
                    </button>
                    <button className='prev row' onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"25px" }}>
                        <NavigateBeforeIcon style={{marginRight:"5px"}}/> PREVIOUS
                    </button>
                    <button className='next row' onClick={() => paginate(currentPage + 1)} disabled={indexOfLastItem >= rows.length}
                        style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', marginRight:"5px", height:"25px" }}>
                        NEXT <NavigateNextIcon style={{ marginLeft: "5px" }} />
                    </button>
                    <button className='next row' onClick={() => paginate(totalPages)} disabled={indexOfLastItem >= rows.length}
                        style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', height:"25px"}}>
                        &gt;&gt;
                    </button>
                </div>
                {`${currentPage}/${totalPages}`}
            </div>
            ) :
            <></>}
        </div>
    )
}
function SetInfoForEmployeesBiometrics({header, 
    _cell, 
    employees, 
    setDataToAdd, 
    setAddConfirmation,
    selectedToAdd,
    setSelectedToAdd,
    isSelectAll,
    isAdd,
    setIsAdd
}) {
    const data = _cell.render("Cell").props.row.original;
    const value = _cell.render("Cell").props.value;
    
    const [isChecked, setIsChecked] = useState(false);
    
    useEffect(() => {
        setIsChecked(isSelectAll);
    }, [isSelectAll ]);

    useEffect(() => {
        if(isAdd){
            setIsChecked(false)
            setIsAdd(false)
        }
    }, [isAdd, setIsAdd]);

    const singleAdd = (selectedData) =>{
        setDataToAdd(selectedData);
        setAddConfirmation(true);
    }

    const handleItem = (event) => {
        const checked = event.target.checked;
        setIsChecked(checked);

        if (checked) {
            setSelectedToAdd(prevItems => [...prevItems, data]);
        } else {
            setSelectedToAdd(prevItems => prevItems.filter(i => i !== data));
        }
    };

    if (header === "Photo") {
        return(
            <td>
                <img className="avatarImg" src="images/sample.jpg" alt=""/>
            </td>
        )
    }

    if (header === "Status") {
        if(!value){
            return (
                <td>
                    Pending
                </td>
            )
        }

        return(
            <td>
                {_cell.render("Cell").props.value}
            </td>
        )
    }

    if (header === "") {
        const foundEmployee = employees.find(employee => {
            return employee.employeeId.toString().trim() === data.employeeId.toString().trim()
        })

        if(foundEmployee){
            return(
                <td></td>
            )
        }
        
        return(
            <td>
                <div className="row"  style={{alignItems:"center", justifyContent:"center"}}>
                    <TooltipManage text="Add">
                        <div style={{padding:"0 5px"}} onClick={()=>singleAdd(data)}><PersonAddAltIcon/></div>
                    </TooltipManage>
                    
                    <input type="checkbox" 
                        id="overtime-allowance" 
                        className="checkbox"
                        name="" 
                        checked={isChecked}
                        onChange={handleItem}
                    />
                </div>
                
            </td>
        )
    }

    if(header === "Date Created"
    ){
        const date = new Date(_cell.render("Cell").props.value);
        if(!date) {
            return (
                <td>
                    null
                </td>
            );
        }

        const mm = date.getMonth() + 1; // Adding 1 because getMonth returns 0-indexed months
        const dd = date.getDate();
        const yyyy = date.getFullYear();

        const formattedDateFrom = `${mm}/${dd}/${yyyy}`;
        
        return(
            <td>
                {formattedDateFrom}
            </td>
        )
    }

    return (
        <td {..._cell.getCellProps()}> {_cell.render("Cell")}</td>
    )
}
function Filter(setFilterDataIndex, setActiveRowIds, setSelectedEmployee){
    const [selectedOption, setSelectedOption] = useState('');

    const handleSelectChange = (event) => {
        setSelectedOption(event.target.value);

        switch (event.target.value) {
            case "All":
                setFilterDataIndex(0);
                break;
            case "EmployeeId":
                setFilterDataIndex(1);
                break;
            case "Approved":
                setFilterDataIndex(2);
                break;
            case "Pending":
                setFilterDataIndex(3);
                break;
            default:
                setFilterDataIndex(0);
                break;
        }

        if(setActiveRowIds && setSelectedEmployee){
            setActiveRowIds([]);
            setSelectedEmployee([]);
        }
    };

    return (
        <select id="" className="filterSelect" value={selectedOption} onChange={handleSelectChange} style={{color: "rgb(104, 104, 104)"}}>
            <option value="All">All</option>
            <option value="EmployeeId">Employee Id</option>
            <option value="Approved">Approved</option>
            <option value="Pending">Pending</option>
        </select>
    );
};
function Sort(filterDataIndex, setFilterDataIndex){
    const [selectedOption, setSelectedOption] = useState('');
    const [isSelected, setIsSelected] = useState(false);

    const handleSelectChange = (event) => {
        setSelectedOption(event.target.value);
        setFilterDataIndex(event.target.value);
    };

    useEffect(() => {
        if(filterDataIndex !== ""){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [filterDataIndex]);

    return (
        <select id="" className="filterSelect" value={selectedOption} onChange={handleSelectChange} style={{color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)"}}>
            <option value="" disabled hidden>{`Choose filter`}</option>
            <option value="Name (A to Z)">{`Name (A to Z)`}</option>
            <option value="Name (Z to A)">{`Name (Z to A)`}</option>
            <option value="Employee Id (lowest to highest)">{`Employee Id (lowest to highest)`} </option>
            <option value="Employee Id (highest to lowest)">{`Employee Id (highest to lowest)`}</option>
        </select>
    );
};
function ClassificationFilterDummy(){
    return (
        <select id="employee-select-PagibigReport" value={""} disabled style={{color: "rgb(104, 104, 104)"}}>
        </select>
    );
};
function ClassificationFilter1({classificationId, setClassificationId, setActiveRowIds, setSelectedEmployee}){
    const handleSelectChange = (event) => {
        setClassificationId(event.target.value);

        if(setActiveRowIds && setSelectedEmployee){
            setActiveRowIds([]);
            setSelectedEmployee([]);
        }
    };

    const [data, setData] = useState([]);

    const fetchData = useCallback(async () => {
        const apiUrl = domain + "/api/Classification/active";
        
        try {
            const response = await axios.get(apiUrl, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json' // Include other headers if needed
                }
            });

            setData(response.data); // Set the response data to the state
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }, []);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    return (
        <select id="employee-select-PagibigReport" value={classificationId} onChange={handleSelectChange} style={{color: "rgb(104, 104, 104)"}}>
            <option value={"0"}>All</option>
            {data.map((classificationId) => ( 
                SetClassificationId(classificationId)
            ))}
        </select>
    );
};
function ClassificationFilter2({classificationId, setClassificationId, setActiveRowIds, setSelectedEmployee}){
    const handleSelectChange = (event) => {
        setClassificationId(event.target.value);

        if(setActiveRowIds && setSelectedEmployee){
            setActiveRowIds([]);
            setSelectedEmployee([]);
        }
    };

    const [data, setData] = useState([]);

    const fetchData = useCallback(async () => {
        const apiUrl = domain + "/api/Classification/active";
        
        try {
            const response = await axios.get(apiUrl, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json' // Include other headers if needed
                }
            });

            setData(response.data); // Set the response data to the state
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }, []);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    return (
        <select id="employee-select-PagibigReport" value={classificationId} onChange={handleSelectChange} style={{color: "rgb(104, 104, 104)"}}>
            {data.map((classificationId) => ( 
                <React.Fragment key={classificationId.id}>
                    {classificationId.id === 2 && (
                        SetClassificationId(classificationId)
                    )}
                    {classificationId.id === 3 && (
                        SetClassificationId(classificationId)
                    )}
                    {classificationId.id === 4 && (
                        SetClassificationId(classificationId)
                    )}
                </React.Fragment>
            ))}
        </select>
    );
};
function ClassificationFilter3({classificationId, setClassificationId, setActiveRowIds, setSelectedEmployee}){
    const handleSelectChange = (event) => {
        setClassificationId(event.target.value);

        if(setActiveRowIds && setSelectedEmployee){
            setActiveRowIds([]);
            setSelectedEmployee([]);
        }
    };

    const [data, setData] = useState([]);

    const fetchData = useCallback(async () => {
        const apiUrl = domain + "/api/Classification/active";
        
        try {
            const response = await axios.get(apiUrl, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json' // Include other headers if needed
                }
            });

            setData(response.data); // Set the response data to the state
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }, []);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    return (
        <select id="employee-select-PagibigReport" value={classificationId} onChange={handleSelectChange} style={{color: "rgb(104, 104, 104)"}}>
            {data.map((classificationId) => ( 
                <React.Fragment key={classificationId.id}>
                    {classificationId.id === 4 && (
                        SetClassificationId(classificationId)
                    )}
                </React.Fragment>
            ))}
        </select>
    );
};
function SetClassificationId(classificationId){
    return(
        <option value={classificationId.id}>{
            classificationId.description}
        </option>
    )
}
function SectionIdSelect({sectionId, setSectionId}){
    
    const handleSelectChange = (event) => {
        setSectionId(event.target.value);
    };

    const [data, setData] = useState([]);

    const fetchData = async () => {
        const apiUrl =  domain + "/api/Section/active";

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            response.data.sort((a, b) => a.description.localeCompare(b.description));
            setData(response.data); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <div>
            <select id="employee-select-PagibigReport" value={sectionId} onChange={handleSelectChange}style={{ color: "rgb(104, 104, 104)" }}>
            <option value="0" >All</option>
            {data.map((sectionId) => ( 
                SetSectionId(sectionId)
            ))}
            </select>
        </div>
    );
};
function SetSectionId(sectionId){
    return(
        <option value={sectionId.id}>{
            sectionId.description}
        </option>
    )
    
}
function LocationIdSelect({locationId, setLocationId}){
    const [isSelected, setIsSelected] = useState(false);

    const handleSelectChange = (event) => {
        setIsSelected(true);
        setLocationId(event.target.value);
    };

    const [data, setData] = useState([]);

    const fetchData = async () => {
        const apiUrl =  domain + "/api/Location/active";

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            response.data.sort((a, b) => a.description.localeCompare(b.description));
            setData(response.data); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }

    useEffect(() => {
        fetchData();
        if(locationId !== "" && locationId !== 0){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [locationId]);

    return (
        <div>
            <select id="employee-select-PagibigReport" value={locationId} onChange={handleSelectChange}style={{ height: "30px", color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
            <option value="0" >All</option>
            {data.map((locationId) => ( 
                SetLocationId(locationId)
            ))}
            </select>
        </div>
    );
};
function SetLocationId(locationId){
    return(
        <option value={locationId.id}>{
            locationId.description}
        </option>
    )

}
const TooltipManage = ({ text, children }) => {
    const [show, setShow] = useState(false);

    const handleMouseEnter = () => {
        setShow(true);
    };

    const handleMouseLeave = () => {
        setShow(false);
    };

    return (
        <div style={{ position: 'relative', display: 'inline-block',zIndex:"1" }}>
            <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
            {children}
            </div>
            {show && (
            <div
                style={{
                position: 'absolute',
                top: '50%',
                left: '-50%',
                transform: 'translateX(-50%)',
                backgroundColor: 'white',
                color: 'gray',
                padding: '5px',
                borderRadius: '5px',
                boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)"
                }}
            >
                {text}
            </div>
            )}
        </div>
    );
};
function ConfirmationForm({isOpen, 
    onClose, 
    handleConfirm}
){
    const handleClose = () => {
        onClose();
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Add Employee</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body" style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                        <span>Are you sure you want to add this employee?</span>
                    </div>
                    <div className="buttons row" style={{justifyContent:"center", padding:"40px 40px 20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={handleConfirm}
                            style={{marginRight:"5px"}}>
                                ADD
                        </button>
                        <button id="add-family" 
                            className="cancel row"
                            style={{marginRight:"5px", height: "34px", borderRadius: "3px"}}
                            onClick={()=>handleClose()}>
                                CANCEL
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function ConfirmationBulkForm({isOpen, 
    onClose, 
    handleConfirm}
){
    const handleClose = () => {
        onClose();
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Add Employee/s</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body" style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                        <span>Are you sure you want to add this employee?</span>
                    </div>
                    <div className="buttons row" style={{justifyContent:"center", padding:"40px 40px 20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={handleConfirm}
                            style={{marginRight:"5px"}}>
                                ADD
                        </button>
                        <button id="add-family" 
                            className="cancel row"
                            style={{marginRight:"5px", height: "34px", borderRadius: "3px"}}
                            onClick={()=>handleClose()}>
                                CANCEL
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function UnapprovedEmployeeModal({isOpen, 
    onClose,
    employees,
})
{
    const handleClose = () => {
        onClose();
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Added / Unapproved Employees</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body">
                        <div className='column'>
                            <div style={{margin: "10px 0 30px 0"}}>
                                This is the list of unapproved employees. 
                                <br/>
                                <br/>To approve this, select "Pending" in filter then select employee and click "Approve". 
                            </div>
                            {employees.map((employee, index) => {
                                return (
                                    <div key={index} style={{margin: "10px 0"}}>
                                        {`${employee.employeeId} - ${employee.fullName}`}
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"20px 40px"}}>
                        <button id="add-family" 
                            className="cancel row"
                            onClick={handleClose}>
                                Close
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
export default EmployeesList
